import { filter, keyBy, map, padStart, range, pickBy, get, isEmpty, toLower, includes, has, some, toUpper, find, } from 'lodash';
import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
import { countries, regions } from './countries';
import { depositStatuses, depositVendors } from './deposits';
import { documentTypes } from './documents';
import { regulators } from './regulators';
import { help2payWithdrawalBanks } from './help2payBanks';
import { payRetailersWithdrawalBanks, payRetailersDocumentTypes, payRetailersBankAccountTypes, payRetailersPayoutBeneficiaryTypeCodes } from './payRetailers';
import { paytrustPaymentOptions, nganLuongBankCodeOptions, zotapayBanks, directa24TaxNumberLabels, dusupayPaymentTypes, letknowpayCryptoCurrencies, cardpayPaymentTypes, chipPayCryptoCurrencies, safechargePaymentTypes, bridgerPayPaymentTypes, speedlightpayPartnerCryptoCurrencies, speedlightpayCryptoCurrencies } from './payments';
import { FieldType } from './types';
import { echelonpayDepositBanks } from './echelonpayBanks';
import { SPEIDepositBanks } from './speiBanks';
import { daviviendabankAccountTypes, daviviendabankDocumentTypes, DaviviendaDepositBanks } from './daviviendaBanks';
import { PayRetailersDepositBanks } from './PayretailersPixBanks';
import { PixDepositBanks } from './PixDepositBanks';
import { OTC365VNDBanks } from './otc365-banks';
import { exactlyBankAccountTypes, ExactlyWithdrawalBanks } from './exactlyBanks';
import { CellulantWithdrawalBanks, CellulantWithdrawalProviders } from './cellulantBanks';
import { beetellerDocumentTypes, beetellerAccountTypes } from './beeteller';
import { clientTypes } from './client';
import { _12PayBanks } from './1-2PayBanks';
function generateMonthOptions() {
    const monthOptions = {};
    const months = range(1, 12 + 1).map((month) => ({ key: month, label: padStart(month.toString(), 2, '0') }));
    months.forEach((y) => {
        monthOptions[y.key] = y;
    });
    return monthOptions;
}
function generateYearOptions() {
    const startYear = new Date().getFullYear();
    const endYear = startYear + 20;
    const yearOptions = {};
    const years = range(startYear, endYear + 1).map((y) => ({ key: y, label: y }));
    years.forEach((y) => {
        yearOptions[y.key] = y;
    });
    return yearOptions;
}
export const withdrawalProcessTime = generateLocalization('withdrawalProcessTime', generateKeys({
    upTo1Hour: {
        label: 'up to 1 hour',
        localization: { id: '', defaultMessage: '' },
    },
    from1To2Hours: {
        label: '1-2 hours',
        localization: { id: '', defaultMessage: '' },
    },
    within24Hours: {
        label: 'within 24 hours',
        localization: { id: '', defaultMessage: '' },
    },
    from2to7days: {
        label: '2-7 working days',
        localization: { id: '', defaultMessage: '' },
    },
    upTo3days: {
        label: 'up to 3 working days',
        localization: { id: '', defaultMessage: '' },
    },
    upTo5days: {
        label: '(on average) up to 5 working days',
        localization: { id: '', defaultMessage: '' },
    },
    within48Hours: {
        label: 'within 48 hours',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const withdrawalReasons = generateLocalization('withdrawalReasons', generateKeys({
    help: {
        label: 'I need help learning to trade',
        showTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    profit: {
        label: 'I want to withdraw my profit',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    tradingPlatform: {
        label: 'The trading platform is too difficult to use',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    mobileApp: {
        label: 'The mobile app is too difficult to use or doesn’t work',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    tradingWithOtherBroker: {
        label: 'I’m trading with another broker',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const skrillAutoProcessActions = generateKeys({
    prepare: {},
    transfer: {},
    refund: {},
});
export const easyEftBankAccountTypes = generateKeys({
    cheque: {
        value: 'cheque',
        label: 'Cheque',
    },
    savings: {
        value: 'saving',
        label: 'Saving',
    },
});
export const directa24BankAccountTypes = generateKeys({
    current: {
        value: 'C',
        label: 'Current Account',
    },
    saving: {
        value: 'S',
        label: 'Saving Account',
    },
    salary: {
        value: 'V',
        label: 'Salary Account',
    },
    joint_checking: {
        value: 'O',
        label: 'Joint Checking Account',
    },
    joint_saving: {
        value: 'P',
        label: 'Joint Savings Account',
    },
});
export const razorpayAccountTypes = generateKeys({
    bankAccount: {
        value: 'bank_account',
        label: 'Bank Account',
    },
    vpa: {
        value: 'vpa',
        label: 'VPA (UPI ID)',
    },
    card: {
        value: 'card',
        label: 'Card',
    },
});
export const easyEftWithdrawBanks = generateKeys({
    absa: {
        value: 'ABSA',
        label: 'ABSA',
        branch: '632005',
    },
    fnb: {
        value: 'FNB',
        label: 'FNB',
        branch: '250655',
    },
    standard: {
        value: 'Standard',
        label: 'Standard',
        branch: '051001',
    },
    nedbank: {
        value: 'Nedbank',
        label: 'Nedbank',
        branch: '198765',
    },
    capitec: {
        value: 'Capitec',
        label: 'Capitec',
        branch: '470010',
    },
    investec: {
        value: 'Investec',
        label: 'Investec',
        branch: '580105',
    },
    tymebank: {
        value: 'TymeBank',
        label: 'TymeBank',
        branch: '678910',
    },
});
export const withdrawalStatuses = generateLocalization('withdrawalStatuses', generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
        userUpdatable: false,
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        userUpdatable: false,
        localization: { id: '', defaultMessage: '' },
    },
    processing: {
        value: 'processing',
        label: 'Processed',
        userUpdatable: false,
        localization: { id: '', defaultMessage: '' },
    },
    notProcessed: {
        value: 'not_processed',
        label: 'Not Processed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    onHold: {
        value: 'on_hold',
        label: 'On Hold',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    reversed: {
        value: 'reversed',
        label: 'Reversed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
    partiallyReversed: {
        value: 'partially_reversed',
        label: 'Partially Reversed',
        userUpdatable: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const withdrawalTypes = generateLocalization('withdrawalTypes', generateKeys({
    withdrawal: {
        value: 'withdrawal',
        acronym: 'WD',
        label: 'Withdrawal',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    transfer: {
        value: 'transfer',
        acronym: 'TRA',
        label: 'Transfer',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        category: 'transfer',
        localization: { id: '', defaultMessage: '' },
    },
    transferb2b: {
        value: 'transferb2b',
        acronym: 'B2B',
        label: 'Transfer B2B',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        category: 'transfer',
        localization: { id: '', defaultMessage: '' },
    },
    goldDeliveryRequest: {
        value: 'gold_delivery_request',
        acronym: 'GDR',
        label: 'Gold Delivery Request',
        userCreatePermitted: false,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    transferWithdrawalCommisions: {
        value: 'transfer_withdrawal_commisions',
        acronym: 'TWC',
        label: 'Transfer Withdrawal Commissions',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        category: 'transfer',
        localization: { id: '', defaultMessage: '' },
    },
    bonus: {
        value: 'bonus',
        acronym: 'BON',
        label: 'Bonus',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    vps_fee: {
        value: 'vps_fee',
        acronym: 'VPS',
        label: 'VPS Fee',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    inactivityFee: {
        value: 'inactivity_fee',
        acronym: 'INA',
        label: 'Inactivity Fee',
        userCreatePermitted: false,
        userProcessPermitted: false,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalCommisions: {
        value: 'withdrawal_commisions',
        acronym: 'WDC',
        label: 'Withdrawal Commissions',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalIbExpenses: {
        value: 'withdrawal_ib_expenses',
        acronym: 'IB-Expenses',
        label: 'Withdrawal IB Expenses',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalContractorSalary: {
        value: 'withdrawal_contractor_salary',
        acronym: 'Con-Sal',
        label: 'Withdrawal Contractor Salary',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalContractorExpenses: {
        value: 'withdrawal_contractor_expenses',
        acronym: 'Con-Expenses',
        label: 'Withdrawal Contractor Expenses',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackReimbursement: {
        value: 'chargeback_reimbursement',
        acronym: 'CBR',
        label: 'Chargeback Reimbursement',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackFee: {
        value: 'chargeback_fee',
        acronym: 'CBF',
        label: 'Chargeback Fee',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    balanceDeduction: {
        value: 'balance_deduction',
        acronym: 'BLD',
        label: 'Balance Deduction',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    cancellationOfprofits: {
        value: 'cancellation_of_profits',
        acronym: 'COF',
        label: 'Cancellation of Profits',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    adjustmentCorrection: {
        value: 'adjustment_correction',
        acronym: 'ADC',
        label: 'Adjustment/Correction',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    fees: {
        value: 'fees',
        acronym: 'FEE',
        label: 'Fees',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    maintenanceFees: {
        value: 'maintenance_fees',
        acronym: 'MF',
        label: 'Maintenance Fees',
        userCreatePermitted: false,
        userProcessPermitted: false,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    returnedFunds: {
        value: 'returned_funds',
        acronym: 'RF',
        label: 'Returned Funds',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    transferSpoa: {
        value: 'transferSpoa',
        acronym: 'SPOA',
        label: 'Transfer SPOA',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        category: 'transfer',
        localization: { id: '', defaultMessage: '' },
    },
    transferSpoab2b: {
        value: 'transferSpoab2b',
        acronym: 'SPOAB',
        label: 'Transfer SPOA B2B',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: true,
        category: 'transfer',
        localization: { id: '', defaultMessage: '' },
    },
    performanceFee: {
        value: 'performance_fee',
        acronym: 'PF',
        label: 'Performance Fee',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    creditBonus: {
        value: 'credit_bonus',
        acronym: 'CRB',
        label: 'Credit Bonus',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    dividend: {
        value: 'dividend',
        acronym: 'DVI',
        label: 'Dividend',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    losableCreditBonus: {
        value: 'losable_credit_bonus',
        acronym: 'LCB',
        label: 'Losable Credit Bonus',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    ldTransfer: {
        value: 'ld_transfer',
        acronym: 'LDT',
        label: 'Payment Agent Transfer',
        userCreatePermitted: true,
        userProcessPermitted: true,
        clientCreatePermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const processWithdrawalResults = generateKeys({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
    process: {
        value: 'process',
        label: 'Process',
    },
    onHold: {
        value: 'onHold',
        label: 'On Hold',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
});
export const withdrawalRejectionReasons = generateLocalization('withdrawalRejectionReasons', generateKeys({
    resubmitCreditCard: {
        label: 'Please resubmit your withdrawal back to the same credit/debit that you have used for deposit',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitSkrillAccount: {
        label: 'Please resubmit your withdrawal back to the same Skrill Account that you have used for deposit',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitNetellerAccount: {
        label: 'Please resubmit your withdrawal back to the same Neteller Account that you have used for deposit',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitBankAccount: {
        label: 'Please resubmit your withdrawal back to the same Bank Account that you have used for deposit',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitWallet: {
        label: 'Please resubmit your withdrawal back to the same wallet address that you have used to deposit.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    insufficientFreeMargin: {
        label: 'You have insufficient free margin on your account, due to open positions. Please resubmit your withdrawal once your positions have been closed.',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawProfits: {
        label: 'Your initial deposits have been refunded and profits should be withdrawn via Bank Transfer. Please resubmit your request via Bank Wire and ensure you provide us with a copy of your bank statement in case you have never funded your account using bank wire.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    eWallet: {
        label: 'The withdrawable amount is too small to be processed via Bank Wire. Please resubmit your request using an e-wallet account under your name (e.g. Skrill, Neteller).',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    smallerThanWithdrawalFees: {
        label: 'The requested amount is smaller than the applicable withdrawal fees. Please refer to our Terms & Conditions to learn more about minimum withdrawal requirements.',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingProofOfId: {
        label: 'Due to missing Proof of Identification',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackFraud: {
        label: 'Due to chargeback/fraud on your account',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    invalidBankDetail: {
        label: 'Due to invalid bank account details',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    insufficientFunds: {
        label: 'Due to insufficient funds',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    failedEmailRespond: {
        label: 'Failed to respond to our emails',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingKycDoc: {
        label: 'Due to missing KYC documentation',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingProofAddress: {
        label: 'Due to missing Proof of Address',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    activeBonus: {
        label: 'Due to active bonus on the account',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    clientRequest: {
        label: 'As per your request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateRequest: {
        label: 'Duplicate request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    thirdPartyFirst: {
        label: 'Third party first',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitToDepositMethod: {
        label: 'Please resubmit the Withdrawal Request back to the same method of deposit used',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingDocuments: {
        label: 'Failed to provide required documentation within 24 working hours',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const withdrawalPendingReasons = generateLocalization('withdrawalPendingReasons', generateKeys({
    proofOfPayment: {
        label: 'Proof of payment, e.g. a screenshot confirming acquiring the coins and stating your wallet address details. The withdrawal needs to be sent back to the Personal wallet used for your deposit.',
        showReasonTextArea: false,
        showCTA: true,
        suppressEmail: true,
        localization: { id: '', defaultMessage: '' },
    },
    bankCardStatement: {
        label: 'Bank/Card statement (or other supporting document), which confirms the source account of your deposits. The document/s should show your name, the source account details and the transaction/s executed to the Company.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    bankPersonalInfoStatement: {
        label: 'Bank statement which shows your full name, address and the bank details you wish to withdraw your funds to.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    identificationDocument: {
        label: 'Please provide us with your identification document as the name on your withdrawal request does not match the name of your profile.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    iban: {
        label: 'In order to proceed with your withdrawal request please provide us with the full IBAN number in the following format: GB00 0000 0000 0000 0000 00.',
        showReasonTextArea: false,
        showCTA: true,
        localization: { id: '', defaultMessage: '' },
    },
    walletSceenshot: {
        label: 'Screenshot of personal wallet needed',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    walletSceenshotNotUploaded: {
        label: 'The screenshot of the private wallet was not uploaded',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const withdrawalPaymentVendors = generateLocalization('withdrawalPaymentVendors', generateKeys({
    neteller: {
        value: 'neteller',
        acronym: 'NET',
        label: 'Neteller',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.skrill.value, depositVendors.neteller.value],
        localization: { id: '', defaultMessage: '' },
        groupName: 'eWallet',
        processTime: withdrawalProcessTime.upTo1Hour,
        common: true,
        commonIbAff: true,
        order: 3,
        withdrawalDetail: 'vendorAccountEmail',
        disabled: ({ country }) => toLower(country) === countries.ca.key,
    },
    skrill: {
        value: 'skrill',
        acronym: 'SKR',
        label: 'Skrill',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.skrill.value],
        localization: { id: '', defaultMessage: '' },
        groupName: 'eWallet',
        processTime: withdrawalProcessTime.upTo1Hour,
        common: true,
        commonIbAff: true,
        withdrawalDetail: 'vendorAccountEmail',
        order: 2,
    },
    netellerSkrill: {
        value: 'neteller_skrill',
        acronym: 'NK',
        label: 'Neteller/Skrill',
        withdrawalAutoTransfer: true,
        disabled: () => true,
        localization: { id: '', defaultMessage: '' },
        groupName: 'eWallet',
    },
    creditDebitCard: {
        value: 'credit_debit_card',
        acronym: 'CC',
        label: 'Credit/Debit Card',
        withdrawalAutoTransfer: true,
        withdrawalDetail: 'cardNumber',
        correspondingDepositVendors: ({ company }) => {
            const vendors = [
                depositVendors.safecharge.value,
                depositVendors.appex.value,
                depositVendors.powercash21.value,
                depositVendors.jmFinancial.value,
                depositVendors.exactly.value,
                depositVendors.link4pay.value,
                depositVendors.paymaxis.value,
            ];
            const regulator = companies[company] && companies[company].regulator;
            if (regulator !== regulators.fsc.value) {
                vendors.push(depositVendors.checkout.value);
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'creditCard',
        processTime: withdrawalProcessTime.from2to7days,
        order: 1,
        withdrawalFees: [
            { min: 0, max: 2, disabled: true },
            { min: 6, max: 0, fee: 0 },
        ],
        disabled: ({ country }) => toLower(country) === countries.ca.key,
    },
    goldDelivery: {
        value: 'gold_delivery',
        acronym: 'GD',
        label: 'Physical Gold Delivery',
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
    },
    bankTransfer: {
        value: 'bank_transfer',
        acronym: 'BANK',
        label: 'Bank Transfer',
        withdrawalAutoTransfer: false,
        hasDynamicWithdrawalFields: true,
        correspondingDepositVendors: (args) => {
            const vendors = [
                depositVendors.manual.value,
                depositVendors.bdxManual.value,
                depositVendors.dotpay.value,
                depositVendors.codapay.value,
                depositVendors.dlocal.value,
                depositVendors.isignthis.value,
                depositVendors.safecharge.value,
                depositVendors.bridgerPay.value,
                depositVendors.cardpay.value,
                depositVendors.bankWire.value,
                depositVendors.powercash21.value,
                depositVendors.klarpay.value,
                depositVendors.directa24.value,
                depositVendors.volt.value,
                depositVendors.zotapay.value,
                depositVendors.easypay.value,
                depositVendors.fincra.value,
            ];
            if (get(args.client, 'address.country') === countries.ca.value) {
                const canadianWithdrawalVendors = [withdrawalPaymentVendors.neteller, withdrawalPaymentVendors.globepay, withdrawalPaymentVendors.astropay, withdrawalPaymentVendors.nganLuong, withdrawalPaymentVendors.help2pay, withdrawalPaymentVendors.creditDebitCard];
                canadianWithdrawalVendors.forEach((vendor) => {
                    const canadianDebitVendors = typeof vendor.correspondingDepositVendors === 'function' ?
                        vendor.correspondingDepositVendors(args) :
                        vendor.correspondingDepositVendors || [];
                    vendors.push(...canadianDebitVendors);
                });
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'bankTransfer',
        processTime: withdrawalProcessTime.upTo5days,
        withdrawalDetail: 'accountNumber',
        common: true,
        commonIbAff: true,
        order: 7,
        pof: documentTypes.bankStatementPOF.key,
        withdrawalFees: [
            { min: 0, max: 60, disabled: true, destination: 'other' },
            { min: 60, max: 100, fee: 0, destination: 'other' },
            { min: 100, max: 0, fee: 0, destination: 'other' },
            { min: 0, max: 15, disabled: true, destination: 'eu' },
            { min: 15, max: 100, fee: 0, destination: 'eu' },
            { min: 100, max: 0, fee: 0, destination: 'eu' },
        ],
    },
    fasapay: {
        value: 'fasapay',
        acronym: 'FAS',
        label: 'Fasapay',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.within24Hours,
        order: 8,
        disabled: () => true,
    },
    dinpay: {
        value: 'dinpay',
        acronym: 'DIN',
        label: 'Dinpay/China Union',
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        groupName: 'other',
        withdrawalDetail: 'bankAccountNumber',
        processTime: withdrawalProcessTime.within24Hours,
    },
    zotapay: {
        value: 'zotapay',
        acronym: 'ZOT',
        label: 'Zotapay',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 9,
        withdrawalDetail: 'bankAccountNumber',
        pof: documentTypes.bankPaymentDetails.key,
    },
    BTC: {
        value: 'btc',
        acronym: 'CP',
        label: 'Bitcoin (BTC)',
        isCrypto: true,
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        groupName: 'coinbase',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 4,
        documentsUpload: [documentTypes.privateWalletAddress.key],
        withdrawalDetail: 'walletAddress',
        disabled: () => true,
    },
    BCH: {
        value: 'bch',
        acronym: 'BCH',
        label: 'Bitcoin Cash (BCH)',
        isCrypto: true,
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        groupName: 'coinbase',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 6,
        withdrawalDetail: 'walletAddress',
        documentsUpload: [documentTypes.privateWalletAddress.key],
    },
    ETH: {
        value: 'eth',
        acronym: 'ETH',
        label: 'Ethereum (ETH)',
        isCrypto: true,
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        groupName: 'coinbase',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 5,
        withdrawalDetail: 'walletAddress',
        documentsUpload: [documentTypes.privateWalletAddress.key],
    },
    globepay: {
        value: 'globepay',
        acronym: 'GLO',
        label: 'Globepay',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [
            depositVendors.globepay.value,
        ],
        groupName: 'eWallet',
        processTime: withdrawalProcessTime.upTo1Hour,
        withdrawalDetail: 'vendorAccountEmail',
        order: 10,
        disabled: ({ country }) => [
            countries.by.key,
            countries.mm.key,
            countries.cd.key,
            countries.ci.key,
            countries.ir.key,
            countries.iq.key,
            countries.lr.key,
            countries.lb.key,
            countries.kp.key,
            countries.sl.key,
            countries.sd.key,
            countries.sy.key,
            countries.zw.key,
        ].includes(toLower(country)),
    },
    divepay: {
        value: 'divepay',
        acronym: 'DIV',
        label: 'Divepay',
        localization: { id: '', defaultMessage: '' },
        groupName: 'eWallet',
        processTime: withdrawalProcessTime.upTo1Hour,
        withdrawalDetail: 'vendorAccountEmail',
        order: 11,
    },
    astropay: {
        value: 'astropay',
        acronym: 'AST',
        label: 'AstroPay',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        common: ({ country }) => [
            countries.co.value,
            countries.qa.value,
            countries.sa.value,
            countries.eg.value,
            countries.ke.value,
            countries.in.value,
            countries.om.value,
            countries.kw.value,
            countries.tz.value,
            countries.bd.value,
        ].includes(country),
        correspondingDepositVendors: [
            depositVendors.astropay.value,
        ],
        allowedCompanies: [
            companies.bdSwissVanuatu.value,
            companies.bdSwissMauritius.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.within24Hours,
        order: 12,
        pof: documentTypes.bankPaymentDetails.key,
        withdrawalDetail: 'beneficiaryPhone',
        disabled: ({ country }) => toLower(country) === countries.ca.key,
    },
    funtopay: {
        value: 'funtopay',
        acronym: 'FTP',
        label: 'Funtopay',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        allowedCompanies: [
            companies.bdSwissVanuatu.value,
            companies.bdSwissMauritius.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'onlineBanking',
        withdrawalDetail: 'bank',
        processTime: withdrawalProcessTime.upTo3days,
    },
    paytrust: {
        value: 'paytrust',
        acronym: 'PTR',
        label: 'Paytrust',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [],
        allowedCompanies: [
            companies.bdSwissVanuatu.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.within24Hours,
        order: 13,
        pof: documentTypes.bankPaymentDetails.key,
        withdrawalDetail: 'bankCode',
        disabled: () => true,
    },
    paymentAsia: {
        value: 'paymentAsia',
        acronym: 'PAA',
        label: 'PaymentAsia',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.paymentAsia.value],
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.within24Hours,
        order: 14,
        pof: documentTypes.bankPaymentDetails.key,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.id.key,
            countries.vn.key,
            countries.my.key,
            countries.ph.key,
        ].includes(toLower(country)),
    },
    easyeft: {
        value: 'easyeft',
        acronym: 'EFT',
        label: 'EasyEFT',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [depositVendors.easyeft.value],
        allowedCompanies: [
            companies.bdSwiss.value,
            companies.bdSwissMauritius.value,
            companies.bdSwissVanuatu.value,
            companies.swissMarkets.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 15,
        pof: documentTypes.bankPaymentDetails.key,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.za.key,
        ].includes(toLower(country)),
    },
    nganLuong: {
        value: 'nganLuong',
        acronym: 'NLU',
        label: 'Ngan Luong',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.nganLuong.value,
            depositVendors.bridgerPay.value,
        ],
        allowedCompanies: [
            companies.bdSwissMauritius.value,
            companies.bdSwissVanuatu.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.within24Hours,
        order: 16,
        pof: documentTypes.bankPaymentDetails.key,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => toLower(country) === countries.ca.key,
    },
    rpnpay: {
        value: 'rpnpay',
        acronym: 'RPN',
        label: 'RPNPay',
        localization: { id: '', defaultMessage: '' },
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.rpnpay.value],
        extraDepositsVendorsForProfits: [
            depositVendors.zotapay.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 17,
        withdrawalDetail: 'bankAccountNumber',
        pof: documentTypes.bankPaymentDetails.key,
    },
    thunderxpay: {
        value: 'thunderxpay',
        acronym: 'TXP',
        label: 'QR/ThunderXpay',
        crmLabel: 'QR/ThunderXpay',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: ({ deposits = [], client }) => {
            const vendors = [
                depositVendors.thunderxpay.value,
            ];
            if (get(client, 'address.country') === countries.th.value && deposits.find((d) => d.vendor === depositVendors.paymentAsia.value)) {
                vendors.push(depositVendors.paymentAsia.value);
            }
            return vendors;
        },
        allowedCompanies: [
            companies.bdSwiss.value,
            companies.bdSwissMauritius.value,
            companies.bdSwissVanuatu.value,
            companies.swissMarkets.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 18,
        pof: documentTypes.bankPaymentDetails.key,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.la.key,
            countries.th.key,
            countries.mm.key,
        ].includes(toLower(country)),
    },
    directa24: {
        value: 'directa24',
        acronym: 'DIR',
        label: 'Directa24',
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        correspondingDepositVendors: [depositVendors.directa24.value],
        allowedCompanies: [
            companies.bdSwiss.value,
            companies.bdSwissMauritius.value,
            companies.bdSwissVanuatu.value,
            companies.swissMarkets.value,
            companies.swissMarketsMauritius.value,
            companies.swissMarketsVanuatu.value,
        ],
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 19,
        pof: documentTypes.bankPaymentDetails.key,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.br.key,
            countries.mx.key,
            countries.co.key,
            countries.pe.key,
            countries.ec.key,
            countries.ke.key,
            countries.ng.key,
        ].includes(toLower(country)),
    },
    paypal: {
        value: 'paypal',
        acronym: 'PP',
        label: 'PayPal',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.paypal.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'paypal',
        processTime: withdrawalProcessTime.within24Hours,
        order: 1,
        withdrawalDetail: 'vendorAccountEmail',
        disabled: ({ company, country }) => {
            if (!company || !country) {
                return false;
            }
            const countryLowerCase = toLower(country);
            const regulator = companies[company].regulator;
            return regulator === regulators.cysec.value || (regulator === regulators.fsc.value &&
                (Boolean(countries[countryLowerCase].isEU) || countryLowerCase === countries.au.key));
        },
    },
    bridgerPay: {
        value: 'bridgerPay',
        acronym: 'BP',
        label: 'Online Banking',
        crmLabel: 'BridgerPay',
        withdrawalAutoTransfer: false,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 20,
    },
    gigadat: {
        value: 'gigadat',
        acronym: 'GIG',
        label: 'Interac® eTransfer',
        crmLabel: 'Gigadat',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.bridgerPay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 20,
        hasFootnote: true,
        withdrawalDetail: 'vendorAccountEmail',
        disabled: () => true,
    },
    interac: {
        value: 'interac',
        acronym: 'INT',
        label: 'Interac® eTransfer',
        crmLabel: 'Safecharge-Interac',
        withdrawalAutoTransfer: true,
        hasDynamicWithdrawalFields: true,
        correspondingDepositVendors: ({ deposits = [] }) => {
            const interacDepositVendors = [depositVendors.safecharge.value];
            if (deposits.some((d) => {
                return d.status === depositStatuses.completed.value && interacDepositVendors.includes(get(d, 'vendor')) &&
                    (get(d, 'receipt.payment_method') === safechargePaymentTypes.interac.value || get(d, 'receipt.data.psp_name') === bridgerPayPaymentTypes.gigadat.value);
            })) {
                return interacDepositVendors;
            }
            return [];
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'other',
        processTime: withdrawalProcessTime.upTo3days,
        order: 1,
        hasFootnote: true,
        withdrawalDetail: 'vendorAccountEmail',
        disabled: () => true,
    },
    help2pay: {
        value: 'help2pay',
        acronym: 'H2P',
        label: 'Help2Pay',
        withdrawalAutoTransfer: true,
        common: ({ country }) => [
            countries.ph.value,
            countries.vn.value,
            countries.my.value,
            countries.id.value,
            countries.th.value,
        ].includes(country),
        correspondingDepositVendors: ({ deposits = [], client }) => {
            const vendors = [
                depositVendors.funtopay.value,
                depositVendors.dinpay.value,
                depositVendors.bridgerPay.value,
                depositVendors.fasapay.value,
                depositVendors.paytrust.value,
            ];
            if (get(client, 'address.country') !== countries.in.value && deposits.find((d) => d.vendor === depositVendors.help2pay.value)) {
                vendors.push(depositVendors.help2pay.value);
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'help2pay',
        processTime: withdrawalProcessTime.within24Hours,
        order: 21,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.ph.key,
            countries.vn.key,
            countries.my.key,
            countries.id.key,
            countries.th.key,
            countries.ru.key,
        ].includes(toLower(country)),
    },
    payRetailers: {
        value: 'payRetailers',
        acronym: 'PRT',
        label: 'Local Transfer / Local Banks',
        withdrawalAutoTransfer: true,
        common: ({ country }) => [
            countries.cr.value,
            countries.br.value,
            countries.cl.value,
            countries.co.value,
            countries.ec.value,
            countries.gt.value,
            countries.mx.value,
            countries.pa.value,
            countries.pe.value,
            countries.sv.value,
        ].includes(country),
        correspondingDepositVendors: [
            depositVendors.payRetailers.value,
            depositVendors.directa24.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'payRetailers',
        withdrawalDetail: 'bankAccountNumber',
        processTime: withdrawalProcessTime.within24Hours,
        order: 22,
    },
    dusupay: {
        value: 'dusupay',
        acronym: 'DSP',
        label: 'Online Banking',
        crmLabel: 'Dusupay',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'dusupay',
        processTime: withdrawalProcessTime.upTo3days,
        order: 23,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'accountNumber',
        disabled: () => true,
    },
    btcproxy: {
        value: 'btcproxy',
        acronym: 'BTP',
        label: 'Crypto',
        crmLabel: 'BTCProxy',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.within24Hours,
        order: 24,
        hasDynamicWithdrawalFields: true,
        documentsUpload: [documentTypes.privateWalletAddress.key],
        withdrawalDetail: 'walletAddress',
        disabled: () => true,
    },
    bitnukSellCrypto: {
        value: 'bitnuk_sell_crypto',
        acronym: 'BSC',
        label: 'Bitnuk/Sell Crypto',
        withdrawalAutoTransfer: false,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 25,
        hasDynamicWithdrawalFields: false,
    },
    bitnukCryptoWithdraw: {
        value: 'bitnuk_crypto_withdraw',
        acronym: 'BCW',
        label: 'Crypto Withdrawal',
        crmLabel: 'Bitnuk/Crypto Withdrawal',
        withdrawalAutoTransfer: false,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 26,
        withdrawalDetail: 'walletAddress',
        hasDynamicWithdrawalFields: false,
    },
    cardpayVndBankTransfer: {
        value: 'cardpay_vnd_bank_transfer',
        acronym: 'CP',
        label: 'Vietnam Bank Transfer',
        crmLabel: 'Cardpay VND - Bank Transfer',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        commonIbAff: true,
        order: 27,
        withdrawalDetail: 'accountNumber',
        disabled: () => true,
    },
    qiwi: {
        value: 'qiwi',
        acronym: 'QIW',
        label: 'Qiwi',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        order: 28,
        disabled: () => true,
    },
    webMoney: {
        value: 'webMoney',
        acronym: 'CP',
        label: 'WebMoney',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        order: 29,
        withdrawalDetail: 'accountNumber',
        disabled: () => true,
    },
    b2bpay: {
        value: 'b2bpay',
        acronym: 'BBP',
        label: 'B2BPay',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        commonIbAff: true,
        withdrawalDetail: 'accountNumber',
        disabled: () => true,
        order: 30,
    },
    mifinity: {
        value: 'mifinity',
        acronym: 'MFT',
        label: 'Mifinity',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.mifinity.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        order: 31,
        disabled: () => true,
    },
    echelonpay: {
        value: 'echelonpay',
        acronym: 'ECH',
        label: 'Local Methods/Echelonpay',
        crmLabel: 'Local Methods/Echelonpay',
        withdrawalAutoTransfer: true,
        common: ({ country }) => [
            countries.cn.value,
            countries.in.value,
            countries.my.value,
            countries.th.value,
            countries.id.value,
        ].includes(country),
        correspondingDepositVendors: [
            depositVendors.echelonpay.value,
            depositVendors.help2pay.value,
            depositVendors.transact365.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        withdrawalDetail: 'accountNumber',
        order: 32,
    },
    usepay: {
        value: 'usepay',
        acronym: 'USE',
        label: 'Online Banking/Usepay',
        crmLabel: 'Online Banking/Usepay',
        withdrawalAutoTransfer: true,
        common: ({ country }) => [
            countries.cn.value,
            countries.my.value,
            countries.id.value,
            countries.th.value,
            countries.vn.value,
        ].includes(country),
        correspondingDepositVendors: [
            depositVendors.usepay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        order: 33,
        withdrawalDetail: 'bankAccountNumber',
        hasDynamicWithdrawalFields: true,
    },
    finrax: {
        value: 'finrax',
        acronym: 'FIN',
        label: 'Crypto Withdrawal (Finrax)',
        crmLabel: 'Finrax Crypto Withdrawal',
        commonIbAff: true,
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: (args) => {
            const vendors = [
                depositVendors.finrax.value,
                depositVendors.depositCommisions.value,
                depositVendors.bridgerPay.value,
            ];
            if (args.deposits.some((d) => d.vendor === depositVendors.cardpay.value &&
                [cardpayPaymentTypes.bitcoin.value, cardpayPaymentTypes.usdtether.value].includes(get(d, 'receipt.payment_method')))) {
                vendors.push(depositVendors.cardpay.value);
            }
            if (get(args.client, 'address.country') === countries.ca.value) {
                const canadianWithdrawalVendors = [withdrawalPaymentVendors.neteller, withdrawalPaymentVendors.globepay, withdrawalPaymentVendors.astropay, withdrawalPaymentVendors.nganLuong, withdrawalPaymentVendors.help2pay, withdrawalPaymentVendors.creditDebitCard];
                canadianWithdrawalVendors.forEach((vendor) => {
                    const canadianDebitVendors = typeof vendor.correspondingDepositVendors === 'function' ?
                        vendor.correspondingDepositVendors(args) :
                        vendor.correspondingDepositVendors || [];
                    vendors.push(...canadianDebitVendors);
                });
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 34,
        withdrawalDetail: 'walletAddress',
        disabled: ({ country }) => [
            countries.af.key,
            countries.al.key,
            countries.bb.key,
            countries.by.key,
            countries.bf.key,
            countries.kh.key,
            countries.ky.key,
            countries.kp.key,
            countries.ht.key,
            countries.ir.key,
            countries.jm.key,
            countries.jo.key,
            countries.ml.key,
            countries.ma.key,
            countries.mm.key,
            countries.ni.key,
            countries.pk.key,
            countries.pa.key,
            countries.ru.key,
            countries.sn.key,
            countries.ss.key,
            countries.sy.key,
            countries.tt.key,
            countries.ug.key,
            countries.vu.key,
            countries.ye.key,
            countries.cn.key,
            countries.tz.key,
            countries.iq.key,
            countries.as.key,
            countries.cu.key,
            countries.er.key,
            countries.ly.key,
            countries.mz.key,
            countries.ps.key,
            countries.so.key,
        ].includes(toLower(country)),
        hasDynamicWithdrawalFields: true,
        walletAcknowledgement: true,
    },
    chipPay: {
        value: 'chipPay',
        acronym: 'OTC',
        label: 'Crypto Withdrawal (ChipPay)',
        crmLabel: 'ChipPay - Crypto Withdrawal',
        common: ({ country }) => [
            countries.ps.value,
            countries.iq.value,
            countries.lb.value,
            countries.mm.value,
            countries.cn.value,
            countries.mz.value,
            countries.ma.value,
            countries.ca.value,
            countries.pk.value,
            countries.bs.value,
            countries.jo.value,
            countries.tr.value,
            countries.bf.value,
            countries.af.value,
            countries.ir.value,
            countries.sy.value,
            countries.dm.value,
            countries.ru.value,
            countries.mw.value,
        ].includes(country),
        correspondingDepositVendors: ({ deposits = [] }) => {
            if (deposits.find((d) => {
                return d.status === depositStatuses.completed.value && depositVendors.otc365.value === get(d, 'vendor') && get(d, 'receipt.rechargeAddress');
            })) {
                return [depositVendors.otc365.value];
            }
            return [];
        },
        withdrawalAutoTransfer: true,
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.upTo5days,
        order: 34,
        withdrawalDetail: 'walletAddress',
        hasDynamicWithdrawalFields: true,
        withdrawalFees: [
            { min: 0, max: 0, fee: 0 },
        ],
        walletAcknowledgement: true,
    },
    otc365: {
        value: 'otc365',
        acronym: 'OTC',
        label: 'Online Banks',
        crmLabel: 'Online Banks - OTC365',
        withdrawalAutoTransfer: true,
        common: ({ country }) => [countries.vn.value].includes(country),
        correspondingDepositVendors: ({ deposits = [] }) => {
            if (deposits.find((d) => {
                return d.status === depositStatuses.completed.value && depositVendors.otc365.value === get(d, 'vendor') && !get(d, 'receipt.rechargeAddress');
            })) {
                return [depositVendors.otc365.value];
            }
            return [];
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        withdrawalDetail: 'bankAccountNumber',
        order: 34,
    },
    spei: {
        value: 'spei',
        acronym: 'spe',
        label: 'SPEI',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        commonIbAff: true,
        order: 33,
        withdrawalDetail: 'bankAccountNumber',
        disabled: () => true,
    },
    daviviendaBank: {
        value: 'davivienda_bank',
        acronym: 'dav',
        label: 'Davivienda Bank',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        commonIbAff: true,
        order: 34,
        withdrawalDetail: 'bankAccountNumber',
        disabled: () => true,
    },
    dokuWallet: {
        value: 'doku_wallet',
        acronym: 'dok',
        label: 'Doku Wallet',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        commonIbAff: true,
        order: 35,
        disabled: () => true,
    },
    letknowpay: {
        value: 'letknowpay',
        acronym: 'LNP',
        label: 'Crypto (LetKnow)',
        crmLabel: 'LetKnowPay Crypto Withdrawal',
        commonIbAff: true,
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: ({ deposits }) => {
            const vendors = [
                depositVendors.letknowpay.value,
                depositVendors.depositCommisions.value,
            ];
            if (deposits.some((d) => d.vendor === depositVendors.cardpay.value &&
                [cardpayPaymentTypes.bitcoin.value, cardpayPaymentTypes.usdtether.value].includes(get(d, 'receipt.payment_method')))) {
                vendors.push(depositVendors.cardpay.value);
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 36,
        withdrawalDetail: 'walletAddress',
        disabled: ({ country }) => [
            countries.af.key,
            countries.dz.key,
            countries.by.key,
            countries.bf.key,
            countries.ca.key,
            countries.cd.key,
            countries.kp.key,
            countries.eg.key,
            countries.ir.key,
            countries.iq.key,
            countries.jo.key,
            countries.ly.key,
            countries.ml.key,
            countries.ma.key,
            countries.mz.key,
            countries.ng.key,
            countries.ne.key,
            countries.pk.key,
            countries.ps.key,
            countries.ru.key,
            countries.sy.key,
            countries.so.key,
            countries.sd.key,
            countries.ss.key,
            countries.tn.key,
            countries.us.key,
            countries.as.key,
            countries.gu.key,
            countries.pr.key,
            countries.vi.key,
            countries.ua.key,
            countries.ye.key,
        ].includes(toLower(country)),
        hasDynamicWithdrawalFields: true,
        walletAcknowledgement: true,
    },
    speedlightpay: {
        value: 'speedlightpay',
        acronym: 'SLP',
        label: 'Crypto (SpeedLightPay)',
        crmLabel: 'SpeedLightpay - Crypto',
        commonIbAff: true,
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.speedlightpay.value,
            depositVendors.depositCommisions.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 50,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'walletAddress',
        disabled: ({ country }) => [
            countries.af.key,
            countries.kp.key,
            countries.ir.key,
            countries.iq.key,
            countries.ps.key,
            countries.sy.key,
            countries.so.key,
            countries.tf.key,
            countries.ca.key,
            countries.cd.key,
            countries.ly.key,
            countries.ml.key,
            countries.sd.key,
            countries.ss.key,
            countries.tn.key,
            countries.us.key,
            countries.as.key,
            countries.gu.key,
            countries.pr.key,
            countries.vi.key,
        ].includes(toLower(country)),
        walletAcknowledgement: true,
    },
    cardpayPix: {
        value: 'cardpay-pix',
        acronym: 'CP',
        label: 'PIX (Cardpay)',
        crmLabel: 'Cardpay - PIX',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cardpay.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        order: 37,
        disabled: () => true,
    },
    payRetailersPix: {
        value: 'payretailers-pix',
        acronym: 'PRT',
        label: 'PIX (Payretailers)',
        crmLabel: 'Payretailers - PIX',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: ({ deposits = [] }) => {
            const vendors = [];
            if (deposits.some((d) => d.vendor === depositVendors.payRetailers.value &&
                get(d, 'meta.paymentMethodName') === 'PIX')) {
                vendors.push(depositVendors.payRetailers.value);
            }
            if (deposits.some((d) => d.vendor === depositVendors.cardpay.value &&
                get(d, 'receipt.payment_method') === cardpayPaymentTypes.pix.value)) {
                vendors.push(depositVendors.cardpay.value);
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.upTo5days,
        withdrawalDetail: 'bankAccountNumber',
        order: 38,
    },
    exactlyThaiBank: {
        value: 'exactlyThaiBank',
        acronym: 'EXL',
        label: 'Exactly Thai Bank',
        crmLabel: 'Exactly Thai Bank',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.exactly.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'crypto',
        processTime: withdrawalProcessTime.from2to7days,
        withdrawalDetail: 'bankAccountNumber',
        order: 39,
    },
    cellulantMobileMoney: {
        value: 'cellulantMobileMoney',
        acronym: 'CELLMM',
        label: 'Mobile money',
        crmLabel: 'Cellulant mobile money',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cellulant.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        order: 40,
    },
    cellulantBank: {
        value: 'cellulantBank',
        acronym: 'CELLB',
        label: 'Bank Transfer (cellulant)',
        crmLabel: 'Cellulant Bank',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.cellulant.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        withdrawalDetail: 'bankAccountNumber',
        order: 41,
    },
    razorpay: {
        value: 'razorpay',
        acronym: 'EZP',
        label: 'Indian Local Methods - Easypay',
        crmLabel: 'Indian Local Methods - Easypay',
        withdrawalAutoTransfer: true,
        groupName: 'onlineBanking',
        localization: { id: '', defaultMessage: '' },
        withdrawalDetail: 'accountNumber',
        disabled: () => true,
        correspondingDepositVendors: [],
        order: 42,
    },
    korapay: {
        value: 'korapay',
        acronym: 'KRP',
        label: 'Korapay',
        crmLabel: 'Korapay',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: ({ client }) => {
            const vendors = [
                depositVendors.korapay.value,
            ];
            if (get(client, 'address.country') === countries.ng.value) {
                vendors.push(depositVendors.ubiqpay.value);
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        common: ({ country }) => [countries.ng.value].includes(country),
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        withdrawalDetail: 'accountNumber',
        order: 43,
        hasDynamicWithdrawalFields: true,
    },
    transact365: {
        value: 'transact365',
        acronym: 'T365',
        label: 'Transact365',
        crmLabel: 'Transact365',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.transact365.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        order: 44,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'accountNumber',
        disabled: ({ country }) => ![
            countries.ch.key,
            countries.vn.key,
            countries.th.key,
            countries.in.key,
        ].includes(toLower(country)),
    },
    ubiqpayBanks: {
        value: 'ubiqpayBanks',
        acronym: 'UBQ',
        label: 'Local banks',
        crmLabel: 'UbiqPay/BANKS',
        withdrawalAutoTransfer: true,
        commonIbAff: true,
        correspondingDepositVendors: ({ deposits }) => {
            const vendors = [
                depositVendors.depositCommisions.value,
            ];
            if (deposits.some((d) => d.vendor === depositVendors.ubiqpay.value
                && depositVendors.ubiqpay.options.bank.value === get(d, 'receipt.payment_method'))) {
                return [depositVendors.ubiqpay.value];
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        order: 45,
        withdrawalDetail: 'bankAccountNumber',
        hasDynamicWithdrawalFields: true,
        disabled: ({ country }) => ![
            countries.za.key,
        ].includes(toLower(country)),
    },
    ubiqpayMobileMoney: {
        value: 'ubiqpayMobileMoney',
        acronym: 'UBQ',
        label: 'Mobile money',
        crmLabel: 'UbiqPay/Mobile Money',
        withdrawalAutoTransfer: true,
        commonIbAff: true,
        correspondingDepositVendors: ({ deposits }) => {
            const vendors = [
                depositVendors.depositCommisions.value,
            ];
            if (deposits.some((d) => d.vendor === depositVendors.ubiqpay.value
                && depositVendors.ubiqpay.options.mobileMoney.value === get(d, 'receipt.payment_method'))) {
                return [depositVendors.ubiqpay.value];
            }
            return vendors;
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'mobileMoney',
        processTime: withdrawalProcessTime.from2to7days,
        order: 46,
        hasDynamicWithdrawalFields: true,
        disabled: ({ country }) => ![
            countries.zm.key,
            countries.ci.key,
            countries.sn.key,
            countries.tz.key,
            countries.ug.key,
            countries.gh.key,
            countries.ke.key,
        ].includes(toLower(country)),
    },
    beeteller: {
        value: 'beeteller',
        acronym: 'BTL',
        label: 'Bank Transfer (Beeteller)',
        crmLabel: 'Beeteller - Bank Transfer',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [
            depositVendors.beeteller.value,
        ],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        order: 47,
        withdrawalDetail: 'bankAccountNumber',
        hasDynamicWithdrawalFields: true,
    },
    ldTransfer: {
        value: 'ld_transfer',
        acronym: 'LDT',
        label: 'Transfer to Payment Agent',
        crmLabel: 'Transfer to Payment Agent',
        withdrawalAutoTransfer: false,
        correspondingDepositVendors: [depositVendors.ldTransfer.value],
        groupName: 'ldWallet',
        localization: { id: '', defaultMessage: '' },
        order: -1,
    },
    transfer: {
        value: 'transfer',
        acronym: 'TRA',
        label: 'Transfer Withdrawal',
        crmLabel: 'Transfer Withdrawal',
        withdrawalAutoTransfer: false,
        correspondingDepositVendors: [depositVendors.transfer.value],
        groupName: 'other',
        localization: { id: '', defaultMessage: '' },
        order: -2,
        disabled: () => true,
    },
    wallettecBanks: {
        value: 'wallettecBanks',
        acronym: 'WLT',
        label: 'Local banks',
        crmLabel: 'EFT Payments / WLT',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: ({ deposits }) => {
            if (deposits.some((d) => d.vendor === depositVendors.wallettec.value
                && depositVendors.wallettec.options.bank.value === get(d, 'meta.paymentKey'))) {
                return [depositVendors.wallettec.value];
            }
            return [];
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from2to7days,
        order: 48,
        hasDynamicWithdrawalFields: true,
        withdrawalDetail: 'bankAccountNumber',
        disabled: ({ country }) => ![
            countries.za.key,
            countries.ng.key,
        ].includes(toLower(country)),
    },
    wallettecMobileMoney: {
        value: 'wallettecMobileMoney',
        acronym: 'WLT',
        label: 'Local Mobile Money',
        crmLabel: 'Local Mobile Money / WLT',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: ({ deposits }) => {
            if (deposits.some((d) => d.vendor === depositVendors.wallettec.value
                && depositVendors.wallettec.options.mobileMoney.value === get(d, 'meta.paymentKey'))) {
                return [depositVendors.wallettec.value];
            }
            return [];
        },
        localization: { id: '', defaultMessage: '' },
        groupName: 'mobileMoney',
        processTime: withdrawalProcessTime.from2to7days,
        order: 49,
        hasDynamicWithdrawalFields: true,
        disabled: ({ country }) => ![
            countries.gh.key,
            countries.ke.key,
            countries.tz.key,
            countries.ug.key,
            countries.zm.key,
            countries.rw.key,
            countries.cm.key,
        ].includes(toLower(country)),
    },
    _1_2PAY: {
        value: '_1_2PAY',
        acronym: '12Pay',
        label: 'QR Codes / 1-2-Pay',
        crmLabel: 'QR Codes / 1-2-Pay',
        withdrawalAutoTransfer: true,
        processTime: withdrawalProcessTime.from1To2Hours,
        correspondingDepositVendors: [depositVendors._1_2_pay.value],
        groupName: 'qrCode',
        hasDynamicWithdrawalFields: true,
        localization: { id: '', defaultMessage: '' },
        withdrawalDetail: 'bankAccountNumber',
        order: 50,
    },
    fincraBanks: {
        value: 'fincraBanks',
        acronym: 'FNC',
        label: 'Local banks',
        crmLabel: 'Local Methods / Fincra',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.fincra.value],
        localization: { id: '', defaultMessage: '' },
        groupName: 'onlineBanking',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 51,
        hasDynamicWithdrawalFields: true,
        disabled: ({ country }) => [
            countries.gh.key,
            countries.ke.key,
            countries.ug.key,
        ].includes(toLower(country)),
    },
    fincraMobileMoney: {
        value: 'fincraMobileMoney',
        acronym: 'FNC',
        label: 'Local Mobile Money',
        crmLabel: 'Local Methods / Fincra',
        withdrawalAutoTransfer: true,
        correspondingDepositVendors: [depositVendors.fincra.value],
        localization: { id: '', defaultMessage: '' },
        groupName: 'mobileMoney',
        processTime: withdrawalProcessTime.from1To2Hours,
        order: 52,
        hasDynamicWithdrawalFields: true,
        disabled: ({ country }) => [
            countries.ng.key,
        ].includes(toLower(country)),
    },
}));
export const withdrawalPaymentFields = generateLocalization('withdrawalPaymentFields', generateKeys({
    nuveiUpo: {
        value: 'nuvei_upo',
        label: 'Account',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.interac.key],
        options: (params) => {
            const { dynamicFields } = params;
            const options = [...get(dynamicFields, 'nuveiUpo', []), { value: 'createNew', label: 'Create new' }];
            return generateKeys(options.reduce((a, o) => Object.assign(a, { [o.value]: o }), {}));
        },
    },
    bankTransferDetails: {
        value: 'bank_transfer_details',
        label: 'Bank Details',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.bankTransfer.key],
        options: (params) => {
            const { dynamicFields } = params;
            const options = [...get(dynamicFields, 'bankTransferDetails', []), { value: 'createNew', label: 'Create new' }];
            return generateKeys(options.reduce((a, o) => Object.assign(a, { [o.value]: o }), {}));
        },
    },
    amount: {
        value: 'amount',
        label: 'Amount',
        commonField: true,
        localization: { id: '', defaultMessage: '' },
        fieldType: FieldType.amount,
    },
    withdrawalReason: {
        value: 'withdrawal_reason',
        label: 'Withdrawal reason',
        commonField: false,
        options: withdrawalReasons,
        localization: { id: '', defaultMessage: '' },
    },
    withdrawalReasonText: {
        value: 'withdrawal_reason_text',
        label: 'Withdrawal reason text',
        localization: { id: '', defaultMessage: '' },
        visible: (fields) => fields.withdrawalReason === 'other',
    },
    vendorAccountEmail: {
        value: 'vendor_account_email',
        label: 'Email Address',
        localization: { id: '', defaultMessage: '' },
        hidden: ({ paymentVendor, values }) => {
            if (paymentVendor !== withdrawalPaymentVendors.interac.value) {
                return false;
            }
            return (values && !values.nuveiUpo) || (values && values.nuveiUpo !== 'createNew');
        },
        depositFields: {
            [depositVendors.skrill.value]: 'pay_from_email',
        },
        paymentVendors: [withdrawalPaymentVendors.skrill.key, withdrawalPaymentVendors.neteller.key,
            withdrawalPaymentVendors.globepay.key, withdrawalPaymentVendors.divepay.key,
            withdrawalPaymentVendors.paypal.key, withdrawalPaymentVendors.gigadat.key,
            withdrawalPaymentVendors.interac.key,
        ],
        fieldType: FieldType.email,
    },
    personalId: {
        value: 'personal_id',
        label: 'Bank account number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.cardpayPix.key,
        ],
    },
    cardNumber: {
        value: 'card_number',
        label: 'Card number (last 4 digits)',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.creditDebitCard.key],
        fieldType: FieldType.creditCardNumber,
    },
    fullName: {
        value: 'full_name',
        label: 'Full name',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.spei.key,
            withdrawalPaymentVendors.razorpay.key,
        ],
    },
    cardHolderName: {
        value: 'card_holder_name',
        label: 'Cardholder name',
        localization: { id: '', defaultMessage: '' },
        depositFields: {
            [depositVendors.spreedly.value]: 'payment_method.full_name',
            [depositVendors.kalixa.value]: 'account.holderName',
        },
        paymentVendors: [withdrawalPaymentVendors.creditDebitCard.key, withdrawalPaymentVendors.dinpay.key],
    },
    cardExpiryMonth: {
        value: 'card_expiry_month',
        label: 'Card expiry month',
        localization: { id: '', defaultMessage: '' },
        depositFields: {
            [depositVendors.spreedly.value]: 'payment_method.month',
            [depositVendors.wirecard.value]: 'expiration_month',
            [depositVendors.kalixa.value]: 'account.expiryMonth',
        },
        paymentVendors: [withdrawalPaymentVendors.creditDebitCard.key],
        options: generateMonthOptions(),
    },
    cardExpiryYear: {
        value: 'card_expiry_year',
        label: 'Card expiry year',
        localization: { id: '', defaultMessage: '' },
        depositFields: {
            [depositVendors.spreedly.value]: 'payment_method.year',
            [depositVendors.wirecard.value]: 'expiration_year',
            [depositVendors.kalixa.value]: 'account.expiryYear',
        },
        paymentVendors: [withdrawalPaymentVendors.creditDebitCard.key],
        options: generateYearOptions(),
    },
    iban: {
        value: 'iban',
        label: 'Bank account / IBAN',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.paytrust.key,
            withdrawalPaymentVendors.bridgerPay.key,
        ],
        fieldType: FieldType.iban,
        hidden: ({ paymentVendor, values, country }) => {
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            if (country === countries.in.key) {
                return true;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    swiftCode: {
        value: 'swift_code',
        label: 'SWIFT/BIC Code',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.bridgerPay.key,
        ],
        hidden: ({ paymentVendor, values }) => {
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    routingNumber: {
        value: 'routing_number',
        label: 'Routing number',
        localization: { id: '', defaultMessage: '' },
        fieldType: FieldType.number,
        paymentVendors: [
            withdrawalPaymentVendors.bankTransfer.key,
        ],
        hidden: ({ paymentVendor, values, country }) => {
            if (![countries.au.key, countries.ca.key].includes(country)) {
                return true;
            }
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    bankAccountHolderName: {
        value: 'holder_name',
        label: 'Bank account holder name',
        localization: { id: '', defaultMessage: '' },
        depositFields: {
            [depositVendors.kalixa.value]: 'account.accountOwner',
        },
        paymentVendors: [
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.zotapay.key,
            withdrawalPaymentVendors.paytrust.key,
            withdrawalPaymentVendors.easyeft.key,
            withdrawalPaymentVendors.nganLuong.key,
            withdrawalPaymentVendors.rpnpay.key,
            withdrawalPaymentVendors.thunderxpay.key,
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.bridgerPay.key,
            withdrawalPaymentVendors.otc365.key,
            withdrawalPaymentVendors.cellulantBank.key,
            withdrawalPaymentVendors.ubiqpayBanks.key,
            withdrawalPaymentVendors.wallettecBanks.key,
            withdrawalPaymentVendors._1_2PAY.key,
            withdrawalPaymentVendors.fincraBanks.key,
            withdrawalPaymentVendors.fincraMobileMoney.key,
        ],
        hidden: ({ paymentVendor, values }) => {
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    bankName: {
        value: 'bank_name',
        label: 'Bank name',
        localization: { id: '', defaultMessage: '' },
        depositFields: {
            [depositVendors.kalixa.value]: 'account.bankName',
        },
        paymentVendors: [
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.dinpay.key,
            withdrawalPaymentVendors.rpnpay.key,
            withdrawalPaymentVendors.bridgerPay.key,
            withdrawalPaymentVendors.cardpayVndBankTransfer.key,
            withdrawalPaymentVendors.b2bpay.key,
            withdrawalPaymentVendors.otc365.key,
        ],
        options: (params) => {
            const { withdrawalPaymentVendor, country } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.otc365.key && country.toUpperCase() === countries.vn.value) {
                return OTC365VNDBanks;
            }
            return null;
        },
        hidden: ({ paymentVendor, values }) => {
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    bankCodeString: {
        value: 'bank_code_string',
        label: 'Bank code',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.b2bpay.key,
        ],
    },
    bankCode: {
        value: 'bank_code',
        label: 'Bank',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.paytrust.key,
            withdrawalPaymentVendors.nganLuong.key,
            withdrawalPaymentVendors.zotapay.key,
            withdrawalPaymentVendors.thunderxpay.key,
            withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.help2pay.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.cardpayPix.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.echelonpay.key,
            withdrawalPaymentVendors.spei.key,
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.usepay.key,
            withdrawalPaymentVendors.exactlyThaiBank.key,
            withdrawalPaymentVendors.cellulantBank.key,
            withdrawalPaymentVendors.korapay.key,
            withdrawalPaymentVendors.transact365.key,
            withdrawalPaymentVendors.ubiqpayBanks.key,
            withdrawalPaymentVendors.wallettecBanks.key,
            withdrawalPaymentVendors.beeteller.key,
            withdrawalPaymentVendors._1_2PAY.key,
            withdrawalPaymentVendors.fincraBanks.key,
            withdrawalPaymentVendors.fincraMobileMoney.key,
        ],
        hidden: ({ country, paymentVendor }) => paymentVendor === withdrawalPaymentVendors.beeteller.key && country === countries.ar.key,
        options: (params) => {
            const { withdrawalPaymentVendor, country, dynamicFields } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.paytrust.key) {
                return paytrustPaymentOptions;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.zotapay.key) {
                return pickBy(zotapayBanks, (b) => b.country.value === country);
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.nganLuong.key) {
                return nganLuongBankCodeOptions;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.thunderxpay.key) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.paymentAsia.key) {
                return country
                    ? pickBy(paymentAsiaWithdrawalBanks, (b) => b.country.value === country.toUpperCase())
                    : paymentAsiaWithdrawalBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.directa24.key) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.help2pay.key) {
                return help2payWithdrawalBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors._1_2PAY.key) {
                return _12PayBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailers.key) {
                return payRetailersWithdrawalBanks[toLower(country)];
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.usepay.key) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.echelonpay.key) {
                const banks = has(dynamicFields, 'banks')
                    ? get(dynamicFields, 'banks')
                    : echelonpayDepositBanks;
                return some(banks, 'country') && country
                    ? pickBy(banks, (bank) => get(bank, 'country.value', bank.country) === country)
                    : banks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.spei.key) {
                return SPEIDepositBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.daviviendaBank.key) {
                return DaviviendaDepositBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailersPix.key) {
                return PayRetailersDepositBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.cardpayPix.key) {
                return PixDepositBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.exactlyThaiBank.key) {
                return ExactlyWithdrawalBanks;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.cellulantBank.key) {
                return pickBy(CellulantWithdrawalBanks, (b) => get(b, 'country') === country);
            }
            else if ([withdrawalPaymentVendors.korapay.key, withdrawalPaymentVendors.transact365.key].includes(withdrawalPaymentVendor)) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.ubiqpayBanks.key) {
                return get(dynamicFields, 'paymentMethods.0.extra_data', [])
                    .map((o) => ({ value: `${o.bank_code}-${o.bank_name}`, label: o.bank_name }))
                    .reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.beeteller.key) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.wallettecBanks.key) {
                return get(dynamicFields, 'banks');
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.fincraBanks.key
                || withdrawalPaymentVendor === withdrawalPaymentVendors.fincraMobileMoney.key) {
                return get(dynamicFields, 'banks');
            }
            else {
                return [];
            }
        },
    },
    bankBranch: {
        value: 'bank_branch',
        label: 'Bank Branch',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.zotapay.key,
            withdrawalPaymentVendors.rpnpay.key,
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.cardpayVndBankTransfer.key,
            withdrawalPaymentVendors.b2bpay.key,
            withdrawalPaymentVendors.usepay.key,
            withdrawalPaymentVendors.otc365.key,
            withdrawalPaymentVendors.cardpayPix.key,
            withdrawalPaymentVendors.transact365.key,
            withdrawalPaymentVendors.beeteller.key,
        ],
        hidden: ({ country, paymentVendor }) => paymentVendor === withdrawalPaymentVendors.beeteller.key && country !== countries.br.key,
        optional: true,
    },
    accountAgencyNumber: {
        value: 'account_agency_number',
        label: 'Account Agency Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
        ],
        optional: true,
        hidden: (args) => args.country !== 'br',
    },
    payoutBeneficiaryTypeCode: {
        value: 'payout_beneficiary_type_code',
        label: 'Payout Beneficiary Type',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
        ],
        optional: true,
        hidden: (args) => args.country !== 'cl',
        options: payRetailersPayoutBeneficiaryTypeCodes,
    },
    payoutPixKey: {
        value: 'payout_pix_key',
        label: 'PIX Key',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
        ],
        hidden: (args) => args.country !== 'br',
    },
    cpf: {
        value: 'cpf',
        label: 'CPF number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.cardpayPix.key,
        ],
        hidden: (args) => !includes(['AR', 'BR', 'CL', 'CO', 'PE', 'UY'], toUpper(args.country)),
    },
    vendorAccountId: {
        value: 'vendor_account_id',
        label: 'Fasapay account id',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [],
    },
    bankAccountType: {
        value: 'bankAccountType',
        label: 'Account Type',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.easyeft.key,
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.exactlyThaiBank.key,
            withdrawalPaymentVendors.razorpay.key,
            withdrawalPaymentVendors.beeteller.key,
        ],
        options: (params) => {
            const { withdrawalPaymentVendor, country } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.easyeft.key) {
                return easyEftBankAccountTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.directa24.key) {
                const inputCountry = country.toLowerCase();
                if (inputCountry === countries.br.key) {
                    return pickBy(directa24BankAccountTypes, (v) => v.value !== 'V');
                }
                if (inputCountry === countries.cl.key) {
                    return pickBy(directa24BankAccountTypes, (v) => v.value !== 'O' && v.value !== 'P');
                }
                if (inputCountry === countries.co.key || country === countries.pe.key || country === countries.uy.key || country === countries.cn.key) {
                    return pickBy(directa24BankAccountTypes, (v) => v.value === 'C' || v.value === 'S');
                }
                return directa24BankAccountTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailers.key) {
                return payRetailersBankAccountTypes[toLower(country)];
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailersPix.key) {
                return payRetailersBankAccountTypes[toLower(country)];
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.daviviendaBank.key) {
                return daviviendabankAccountTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.exactlyThaiBank.key) {
                return exactlyBankAccountTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.razorpay.key) {
                return razorpayAccountTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.beeteller.key) {
                const info = get(beetellerAccountTypes, country.toLowerCase());
                return isEmpty(info) ? { id: { key: 'id', label: 'ID', value: 'ID' } } : info.options;
            }
            else {
                return [];
            }
        },
    },
    bankAccountNumber: {
        value: 'bank_account_number',
        label: 'Bank Account/ Bank card number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.dinpay.key, withdrawalPaymentVendors.zotapay.key, withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.easyeft.key, withdrawalPaymentVendors.nganLuong.key, withdrawalPaymentVendors.rpnpay.key,
            withdrawalPaymentVendors.thunderxpay.key, withdrawalPaymentVendors.directa24.key, withdrawalPaymentVendors.help2pay.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.spei.key,
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.usepay.key,
            withdrawalPaymentVendors.otc365.key,
            withdrawalPaymentVendors.exactlyThaiBank.key,
            withdrawalPaymentVendors.cellulantBank.key,
            withdrawalPaymentVendors.ubiqpayBanks.key,
            withdrawalPaymentVendors.beeteller.key,
            withdrawalPaymentVendors.wallettecBanks.key,
            withdrawalPaymentVendors._1_2PAY.key,
            withdrawalPaymentVendors.fincraBanks.key,
            withdrawalPaymentVendors.fincraMobileMoney.key,
        ],
    },
    beneficiaryEmail: {
        value: 'beneficiaryEmail',
        label: 'Email Address',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.dokuWallet.key,
            withdrawalPaymentVendors.spei.key,
        ],
        fieldType: FieldType.email,
    },
    beneficiaryFirstName: {
        value: 'beneficiaryFirstName',
        label: 'Beneficiary First Name',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.help2pay.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.gigadat.key,
            withdrawalPaymentVendors.b2bpay.key,
            withdrawalPaymentVendors.dokuWallet.key,
        ],
    },
    beneficiaryLastName: {
        value: 'beneficiaryLastName',
        label: 'Beneficiary Last Name',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.help2pay.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.gigadat.key,
            withdrawalPaymentVendors.b2bpay.key,
            withdrawalPaymentVendors.dokuWallet.key,
        ],
    },
    beneficiaryPhone: {
        value: 'beneficiaryPhone',
        label: 'Phone Number',
        localization: { id: '', defaultMessage: '' },
        hidden: ({ paymentVendor, values }) => {
            if (paymentVendor !== withdrawalPaymentVendors.interac.value) {
                return false;
            }
            return (values && !values.nuveiUpo) || (values && values.nuveiUpo !== 'createNew');
        },
        paymentVendors: [
            withdrawalPaymentVendors.paymentAsia.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.astropay.key,
            withdrawalPaymentVendors.gigadat.key,
            withdrawalPaymentVendors.interac.key,
            withdrawalPaymentVendors.qiwi.key,
            withdrawalPaymentVendors.dokuWallet.key,
            withdrawalPaymentVendors.otc365.key,
            withdrawalPaymentVendors.exactlyThaiBank.key,
            withdrawalPaymentVendors._1_2PAY.key,
        ],
        fieldType: FieldType.phone,
    },
    phoneNumber: {
        value: 'phoneNumber',
        label: 'Phone Number',
        localization: { id: '', defaultMessage: '' },
        fieldType: FieldType.phone,
        paymentVendors: [
            withdrawalPaymentVendors.ubiqpayBanks.key,
            withdrawalPaymentVendors.ubiqpayMobileMoney.key,
            withdrawalPaymentVendors.wallettecBanks.key,
            withdrawalPaymentVendors.wallettecMobileMoney.key,
        ],
        options: (params) => {
            const { withdrawalPaymentVendor, clientType } = params;
            switch (withdrawalPaymentVendor) {
                case withdrawalPaymentVendors.ubiqpayBanks.key:
                case withdrawalPaymentVendors.ubiqpayMobileMoney.key:
                    const phoneNumberOptions = get(params, 'dynamicFields.phoneNumbers', []);
                    const isPartner = [
                        clientTypes.affiliate.value,
                        clientTypes.affiliateCorporate.value,
                        clientTypes.ib.value,
                        clientTypes.ibCorporate.value,
                    ].includes(clientType);
                    if (!phoneNumberOptions.length && isPartner) {
                        return null;
                    }
                    return generateKeys(phoneNumberOptions.reduce((a, o) => Object.assign(a, { [o.value]: o }), {}));
                case withdrawalPaymentVendors.wallettecBanks.key:
                case withdrawalPaymentVendors.wallettecMobileMoney.key:
                    const options = get(params, 'dynamicFields.phoneNumbers', []);
                    return generateKeys(options.reduce((a, o) => Object.assign(a, { [o.value]: o }), {}));
                default:
                    return [];
            }
        },
    },
    bankAccountCity: {
        value: 'bank_account_city',
        label: 'Bank City',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.zotapay.key,
            withdrawalPaymentVendors.usepay.key,
        ],
    },
    bankAccountProvince: {
        value: 'bank_account_province',
        label: 'Bank province',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.zotapay.key,
            withdrawalPaymentVendors.rpnpay.key,
            withdrawalPaymentVendors.usepay.key,
        ],
    },
    bankAccountArea: {
        value: 'bank_account_area',
        label: 'Bank area',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.rpnpay.key],
    },
    cryptoCurrency: {
        value: 'cryptoCurrency',
        label: 'Crypto Currency',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.btcproxy.key,
            withdrawalPaymentVendors.finrax.key,
            withdrawalPaymentVendors.letknowpay.key,
            withdrawalPaymentVendors.chipPay.key,
            withdrawalPaymentVendors.speedlightpay.key,
        ],
        options: (params) => {
            const { dynamicFields, withdrawalPaymentVendor, clientType } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.letknowpay.key) {
                return letknowpayCryptoCurrencies;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.chipPay.key) {
                return chipPayCryptoCurrencies;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.speedlightpay.key) {
                const isPartner = [
                    clientTypes.affiliate.value,
                    clientTypes.affiliateCorporate.value,
                    clientTypes.ib.value,
                    clientTypes.ibCorporate.value,
                ].includes(clientType);
                if (isPartner) {
                    return speedlightpayPartnerCryptoCurrencies;
                }
                else {
                    return speedlightpayCryptoCurrencies;
                }
            }
            return get(dynamicFields, 'currencies');
        },
    },
    network: {
        value: 'network',
        label: 'Network',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.finrax.key,
            withdrawalPaymentVendors.chipPay.key,
        ],
        dependent: true,
        options: (params) => {
            const { dynamicFields, withdrawalPaymentVendor, currency } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.chipPay.key) {
                return get(find(chipPayCryptoCurrencies, { value: currency }), 'networks', {});
            }
            else {
                const networks = get(dynamicFields, 'networks', {});
                return networks[currency] || [];
            }
        },
    },
    walletAddress: {
        value: 'wallet_address',
        label: 'Wallet Address',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.BTC.key,
            withdrawalPaymentVendors.BCH.key,
            withdrawalPaymentVendors.ETH.key,
            withdrawalPaymentVendors.btcproxy.key,
            withdrawalPaymentVendors.bitnukCryptoWithdraw.key,
            withdrawalPaymentVendors.finrax.key,
            withdrawalPaymentVendors.letknowpay.key,
            withdrawalPaymentVendors.chipPay.key,
            withdrawalPaymentVendors.speedlightpay.key,
        ],
    },
    destinationTag: {
        value: 'destinationTag',
        label: 'Destination Tag/Memo',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.finrax.key,
            withdrawalPaymentVendors.letknowpay.key,
            withdrawalPaymentVendors.chipPay.key,
            withdrawalPaymentVendors.speedlightpay.key,
        ],
        dependent: true,
        hidden: ({ currency }) => !['XLM', 'XRP'].includes(currency),
    },
    card: {
        value: 'card',
        label: 'Card number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.funtopay.key,
            withdrawalPaymentVendors.razorpay.key,
        ],
        fieldType: FieldType.creditCardNumber,
        hidden: ({ paymentVendor, values }) => paymentVendor === withdrawalPaymentVendors.razorpay.key && (values && (!values.bankAccountType || values.bankAccountType !== razorpayAccountTypes.card.key)),
    },
    bank: {
        value: 'bank',
        label: 'Bank',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.funtopay.key],
        options: (params) => {
            const { config } = params;
            return config && config.funtopayWithdrawalBanks;
        },
    },
    city: {
        value: 'city',
        label: 'City',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.dokuWallet.key,
        ],
    },
    country: {
        value: 'country',
        label: 'Country',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.dokuWallet.key],
    },
    deliveryAddressLine1: {
        value: 'deliveryAddressLine1',
        label: 'Address Line 1',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.goldDelivery.key,
        ],
    },
    deliveryAddressLine2: {
        value: 'deliveryAddressLine2',
        label: 'Address Line 2',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.goldDelivery.key],
    },
    district: {
        value: 'district',
        label: 'District',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [],
    },
    deliveryAddressRegion: {
        value: 'deliveryAddressRegion',
        label: 'State / Region',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.goldDelivery.key,
        ],
    },
    deliveryAddressCity: {
        value: 'deliveryAddressCity',
        label: 'City',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.goldDelivery.key],
    },
    deliveryAddressZipCode: {
        value: 'deliveryAddressZipCode',
        label: 'Zip/Postal Code',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.goldDelivery.key,
        ],
    },
    deliveryAddressCountry: {
        value: 'deliveryAddressCountry',
        label: 'Country',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.goldDelivery.key],
        options: keyBy(regions.dach.countries, (c) => c.key),
    },
    deliveryAdditionalInstructions: {
        value: 'deliveryAdditionalInstructions',
        label: 'Additional Instructions',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.goldDelivery.key],
    },
    goldValue: {
        value: 'goldValue',
        label: 'Gold Value (OZ)',
        paymentVendors: [withdrawalPaymentVendors.goldDelivery.key],
        visible: () => false,
        localization: { id: '', defaultMessage: '' },
    },
    nameOfBank: {
        value: 'bank_name',
        label: 'Bank Name',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.easyeft.key],
        options: easyEftWithdrawBanks,
    },
    beneficiaryAddress: {
        value: 'beneficiaryAddress',
        label: 'Beneficiary Address',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.directa24.key],
    },
    documentType: {
        value: 'documentType',
        label: 'Document Type',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.beeteller.key,
        ],
        options: (params) => {
            const { country, withdrawalPaymentVendor } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.directa24.key) {
                const info = get(directa24TaxNumberLabels, country.toLowerCase());
                return isEmpty(info) ? { id: { key: 'id', label: 'ID', value: 'ID' } } : info.options;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailers.key) {
                return payRetailersDocumentTypes[toLower(country)];
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.payRetailersPix.key) {
                return payRetailersDocumentTypes[toLower(country)];
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.daviviendaBank.key) {
                return daviviendabankDocumentTypes;
            }
            else if (withdrawalPaymentVendor === withdrawalPaymentVendors.beeteller.key) {
                const info = get(beetellerDocumentTypes, country.toLowerCase());
                return isEmpty(info) ? { id: { key: 'id', label: 'ID', value: 'ID' } } : info.options;
            }
            else {
                return {};
            }
        },
    },
    documentNumber: {
        value: 'documentNumber',
        label: 'Document Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.beeteller.key,
        ],
    },
    document: {
        value: 'document',
        label: 'Identification Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.directa24.key,
            withdrawalPaymentVendors.payRetailers.key,
            withdrawalPaymentVendors.payRetailersPix.key,
        ],
    },
    comment: {
        value: 'comment',
        label: 'Comment',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.directa24.key],
    },
    paymentOption: {
        value: 'payment_option',
        label: 'Payment Option',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.dusupay.key],
        options: (params) => {
            const { country, withdrawalPaymentVendor } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.dusupay.key) {
                return filter(dusupayPaymentTypes, (p) => includes(p.countries, country) && includes(p.types, 'payout'));
            }
            else {
                return [];
            }
        },
    },
    provider: {
        value: 'provider',
        label: 'Provider',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.dusupay.key,
            withdrawalPaymentVendors.ubiqpayMobileMoney.key,
            withdrawalPaymentVendors.cellulantMobileMoney.key,
            withdrawalPaymentVendors.wallettecMobileMoney.key,
        ],
        options: (params) => {
            const { withdrawalPaymentVendor, dynamicFields, paymentOption, country } = params;
            switch (withdrawalPaymentVendor) {
                case withdrawalPaymentVendors.dusupay.key:
                    return filter(get(dynamicFields, 'providers'), (p) => p.paymentOption === paymentOption);
                case withdrawalPaymentVendors.ubiqpayMobileMoney.key:
                    return get(dynamicFields, 'paymentMethods', [])
                        .map((o) => ({ value: o.id, label: o.name }))
                        .reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
                case withdrawalPaymentVendors.cellulantMobileMoney.key:
                    return pickBy(CellulantWithdrawalProviders, (b) => get(b, 'country') === country);
                case withdrawalPaymentVendors.wallettecMobileMoney.key:
                    return get(dynamicFields, 'providers', [])
                        .map((o) => ({ value: o.value, label: o.label }))
                        .reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
                default:
                    return [];
            }
        },
    },
    accountNumber: {
        value: 'account_number',
        label: 'Account Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.dusupay.key,
            withdrawalPaymentVendors.cardpayVndBankTransfer.key,
            withdrawalPaymentVendors.webMoney.key,
            withdrawalPaymentVendors.b2bpay.key,
            withdrawalPaymentVendors.echelonpay.key,
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.razorpay.key,
            withdrawalPaymentVendors.korapay.key,
            withdrawalPaymentVendors.transact365.key,
        ],
        hidden: ({ paymentVendor, values, country }) => {
            if (paymentVendor === withdrawalPaymentVendors.razorpay.key && (values && (!values.bankAccountType || values.bankAccountType !== razorpayAccountTypes.bankAccount.key))) {
                return true;
            }
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            if (country !== countries.in.key) {
                return true;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    branchCode: {
        value: 'branch_code',
        label: 'Branch',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.dusupay.key],
        options: (params) => {
            const { withdrawalPaymentVendor, dynamicFields, bankCode } = params;
            if (withdrawalPaymentVendor === withdrawalPaymentVendors.dusupay.key) {
                return filter(get(dynamicFields, 'branches'), (b) => b.bankCode === bankCode);
            }
            else {
                return [];
            }
        },
        hidden: (args) => !(args.paymentOption === dusupayPaymentTypes.bank.key && args.country === countries.gh.key),
    },
    bankAccountName: {
        value: 'bank_account_name',
        label: 'Bank Account Name',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.cardpayVndBankTransfer.key,
            withdrawalPaymentVendors.echelonpay.key,
            withdrawalPaymentVendors.dokuWallet.key,
            withdrawalPaymentVendors.daviviendaBank.key,
            withdrawalPaymentVendors.usepay.key,
        ],
    },
    taxId: {
        value: 'tax_id',
        label: 'Tax ID Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.b2bpay.key,
        ],
    },
    emailOrEWalletNumber: {
        value: 'email_or_ewallet_number',
        label: 'Email Or eWallet Number',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [withdrawalPaymentVendors.mifinity.key],
    },
    ifscCode: {
        value: 'ifsc_code',
        label: 'IFSC code',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.echelonpay.key,
            withdrawalPaymentVendors.bankTransfer.key,
            withdrawalPaymentVendors.razorpay.key,
            withdrawalPaymentVendors.transact365.key,
        ],
        hidden: ({ paymentVendor, values, country }) => {
            if (country !== countries.in.key) {
                return true;
            }
            if (paymentVendor === withdrawalPaymentVendors.razorpay.key && (values && (!values.bankAccountType || values.bankAccountType !== razorpayAccountTypes.bankAccount.key))) {
                return true;
            }
            if (paymentVendor !== withdrawalPaymentVendors.bankTransfer.key) {
                return false;
            }
            return !(values && (values.bankTransferDetails === 'createNew' || values.bankTransferDetails === ''));
        },
    },
    termsAndConditions: {
        value: 'terms_and_conditions',
        label: 'Withdrawal Terms and Conditions',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: map(filter(withdrawalPaymentVendors, (w) => w.key !== 'goldDelivery'), 'key'),
        fieldType: FieldType.terms,
    },
    withdrawalFee: {
        value: 'withdrawal_fee',
        label: 'Withdrawal Fee',
        isInternal: true,
        localization: { id: '', defaultMessage: '' },
        fieldType: FieldType.amount,
    },
    withdrawalNetAmount: {
        value: 'withdrawal_net_amount',
        label: 'Withdrawal Net Amount',
        isInternal: true,
        localization: { id: '', defaultMessage: '' },
        fieldType: FieldType.amount,
    },
    transferToAccount: {
        value: 'transferToAccount',
        label: 'Destination Account',
        localization: { id: '', defaultMessage: '' },
    },
    vpaAddress: {
        value: 'vpaAddress',
        label: 'VPA Address',
        localization: { id: '', defaultMessage: '' },
        paymentVendors: [
            withdrawalPaymentVendors.razorpay.key,
        ],
        hidden: (args) => args.paymentVendor === withdrawalPaymentVendors.razorpay.key && (args.values && (!args.values.bankAccountType || args.values.bankAccountType !== razorpayAccountTypes.vpa.key)),
    },
}));
export const paymentAsiaWithdrawalBanks = generateKeys({
    AUB_PHP: {
        label: 'Asia United Bank CA/SA',
        value: 'AUB',
        country: countries.ph,
        max: 100000,
    },
    BDO_PHP: {
        label: 'Banco de Oro CA/SA',
        value: 'BDO',
        country: countries.ph,
        max: 130000,
    },
    BPI_PHP: {
        label: 'BPI CA/SA',
        value: 'BPI',
        country: countries.ph,
        max: 130000,
    },
    BFB_PHP: {
        label: 'BPI Family Bank',
        value: 'BFB',
        country: countries.ph,
        max: 100000,
    },
    CBC_PHP: {
        label: 'Chinabank CA/SA',
        value: 'CBC',
        country: countries.ph,
        max: 100000,
    },
    EWB_PHP: {
        label: 'EastWest CA/SA',
        value: 'EWB',
        country: countries.ph,
        max: 100000,
    },
    LBP_PHP: {
        label: 'Landbank CA/SA',
        value: 'LBP',
        country: countries.ph,
        max: 100000,
    },
    MBTC_PHP: {
        label: 'Metrobank CA/SA',
        value: 'MBTC',
        country: countries.ph,
        max: 130000,
    },
    PNB_PHP: {
        label: 'PNB individual CA/SA',
        value: 'PNB',
        country: countries.ph,
        max: 100000,
    },
    RCBC_PHP: {
        label: 'RCBC CA/SA, RCBC Savings Bank CA/SA, RCBC MyWallet',
        value: 'RCBC',
        country: countries.ph,
        max: 100000,
    },
    RSB_PHP: {
        label: 'Robinsons Bank CA/SA',
        value: 'RSB',
        country: countries.ph,
        max: 100000,
    },
    SBC_PHP: {
        label: 'Security Bank CA/SA',
        value: 'SBC',
        country: countries.ph,
        max: 100000,
    },
    UBP_PHP: {
        label: 'Unionbank CA/SA, EON',
        value: 'UBP',
        country: countries.ph,
        max: 130000,
    },
    UCPB_PHP: {
        label: 'UCPB CA/SA',
        value: 'UCPB',
        country: countries.ph,
        max: 100000,
    },
    BOC_PHP: {
        label: 'Bank of Commerce',
        value: 'BOC',
        country: countries.ph,
        max: 50000,
    },
    CBCS_PHP: {
        label: 'Chinabank Savings',
        value: 'CBCS',
        country: countries.ph,
        max: 50000,
    },
    MAY_PHP: {
        label: 'Maybank',
        value: 'MAY',
        country: countries.ph,
        max: 50000,
    },
    SBA_PHP: {
        label: 'Sterling Bank',
        value: 'SBA',
        country: countries.ph,
        max: 50000,
    },
    CTBC_PHP: {
        label: 'Chinatrust',
        value: 'CTBC',
        country: countries.ph,
        max: 50000,
    },
    DBP_PHP: {
        label: 'Development Bank of the Philippines',
        value: 'DBP',
        country: countries.ph,
    },
    PBCM_PHP: {
        label: 'PBCom',
        value: 'PBCM',
        country: countries.ph,
        max: 50000,
    },
    PSB_PHP: {
        label: 'PSBank',
        value: 'PSB',
        country: countries.ph,
        max: 100000,
    },
    PVB_PHP: {
        label: 'Veterans Bank',
        value: 'PVB',
        country: countries.ph,
        max: 50000,
    },
    GCSH_PHP: {
        label: 'GCash',
        value: 'GCSH',
        country: countries.ph,
    },
    PYMY_PHP: {
        label: 'PayMaya',
        value: 'PYMY',
        country: countries.ph,
    },
    KBANK_THB: {
        value: 'KBANK',
        label: 'Kasikorn Bank',
        country: countries.th,
    },
    KTB_THB: {
        value: 'KTB',
        label: 'Krung Thai Bank',
        country: countries.th,
    },
    SCB_THB: {
        value: 'SCB',
        label: 'Siam Commercial Bank',
        country: countries.th,
    },
    BBL_THB: {
        value: 'BBL',
        label: 'Bangkok Bank',
        country: countries.th,
    },
    BAY_THB: {
        value: 'BAY',
        label: 'Bank Of Ayudhya',
        country: countries.th,
    },
    TMB_THB: {
        value: 'TMB',
        label: 'Thai Military Bank',
        country: countries.th,
    },
    GSB_THB: {
        value: 'GSB',
        label: 'Government Savings Bank',
        country: countries.th,
    },
    LHB_THB: {
        value: 'LHB',
        label: 'Land and Houses Bank',
        country: countries.th,
    },
    TBANK_THB: {
        value: 'TBANK',
        label: 'Thanachart Bank',
        country: countries.th,
    },
    KK_THB: {
        value: 'KK',
        label: 'Kiatnakin Bank',
        country: countries.th,
    },
    BAAC_THB: {
        value: 'BAAC',
        label: 'Bank for Agriculture',
        country: countries.th,
    },
    STC_THB: {
        value: 'STC',
        label: 'Standard Chartered Bank Thailand',
        country: countries.th,
    },
    ISBT_THB: {
        value: 'ISBT',
        label: 'Islamic Bank of Thailand',
        country: countries.th,
    },
    CIMBT_THB: {
        value: 'CIMBT',
        label: 'CIMB Thai',
        country: countries.th,
    },
    GHB_THB: {
        value: 'GHB',
        label: 'Government Housing Bank',
        country: countries.th,
    },
    CITI_THB: {
        value: 'CITI',
        label: 'City Bank',
        country: countries.th,
    },
    UOB_THB: {
        value: 'UOB',
        label: 'UOB Bank',
        country: countries.th,
    },
    PANIN_IDR: {
        value: 'PANIN',
        label: 'Bank Panin',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BJ_IDR: {
        value: 'BJ',
        label: 'Bank Jatim',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BAG_IDR: {
        value: 'BAG',
        label: 'Bank Arta Graha',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BTPN_IDR: {
        value: 'BTPN',
        label: 'Bank BTPN',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BJB_IDR: {
        value: 'BJB',
        label: 'Bank BJB',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BMI_IDR: {
        value: 'BMI',
        label: 'Bank Mayapada International',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BP_IDR: {
        value: 'BP',
        label: 'Bank Permata',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BCA_IDR: {
        value: 'BCA',
        label: 'Bank BCA',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BDI_IDR: {
        value: 'BDI',
        label: 'Bank Danamon Indonesia',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    HANA_IDR: {
        value: 'HANA',
        label: 'Bank Hana',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    Bll_IDR: {
        value: 'Bll',
        label: 'Bll MayBank',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BSI_IDR: {
        value: 'BSI',
        label: 'Bank Sinarmas',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BSMA_IDR: {
        value: 'BSMA',
        label: 'Bank Syariah Mandiri',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    CITI_IDR: {
        value: 'CITI',
        label: 'CITIBANK',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BCAS_IDR: {
        value: 'BCAS',
        label: 'BANK BCA SYARIAH',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    NTT_IDR: {
        value: 'NTT',
        label: 'Bank NTT',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BSME_IDR: {
        value: 'BSME',
        label: 'Bank Syariah Mega',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BNTB_IDR: {
        value: 'BNTB',
        label: 'BPD NUSA TENGGARA BARAT',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BMAN_IDR: {
        value: 'BMAN',
        label: 'BANK MANDIRI',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BMU_IDR: {
        value: 'BMU',
        label: 'Bank Muamalat Indonesia',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BNI_IDR: {
        value: 'BNI',
        label: 'Bank BNI 46',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BTN_IDR: {
        value: 'BTN',
        label: 'Bank BTN',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    DBS_IDR: {
        value: 'DBS',
        label: 'Bank DBS Indonesia',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    CIMB_IDR: {
        value: 'CIMB',
        label: 'Bank CIMB Niaga',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BCOM_IDR: {
        value: 'BCOM',
        label: 'Bank Commonwealth',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BUBI_IDR: {
        value: 'BUBI',
        label: 'Bank UOB Buana Indonesia',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPD_IDR: {
        value: 'BPD',
        label: 'BPD Bali',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BON_IDR: {
        value: 'BON',
        label: 'Bank OCBC NISP',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BRI_IDR: {
        value: 'BRI',
        label: 'Bank BRI',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BMEG_IDR: {
        value: 'BMEG',
        label: 'Bank Mega',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    DOKU_IDR: {
        value: 'DOKU',
        label: 'DOKU WALLET',
        country: countries.id,
        min: 100000,
    },
    BBUK_IDR: {
        value: 'BBUK',
        label: 'Bank Bukopin',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    HSBC_IDR: {
        value: 'HSBC',
        label: 'Bank HSBC',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BBS_IDR: {
        value: 'BBS',
        label: 'Bank BRI Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BJAB_IDR: {
        value: 'BJAB',
        label: 'Bank JABAR Banten',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BBNS_IDR: {
        value: 'BBNS',
        label: 'Bank BNI Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    CTBC_IDR: {
        value: 'CTBC',
        label: 'Bank Chinatrust Indonesia',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    MAYO_IDR: {
        value: 'MAYO',
        label: 'Bank Mayora',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    MUTI_IDR: {
        value: 'MUTI',
        label: 'Bank Mutiara',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    NAGA_IDR: {
        value: 'NAGA',
        label: 'Bank Nagari (BPD Sumbar)',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BNN_IDR: {
        value: 'BNN',
        label: 'Bank National Nobu',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    SAUD_IDR: {
        value: 'SAUD',
        label: 'Bank Saudara',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BSC_IDR: {
        value: 'BSC',
        label: 'Bank Standard Chartered',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    SUMU_IDR: {
        value: 'SUMU',
        label: 'Bank Sumut',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BWK_IDR: {
        value: 'BWK',
        label: 'Bank Windu Kencana',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    ACEH_IDR: {
        value: 'ACEH',
        label: 'BPD Aceh',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    JAWA_IDR: {
        value: 'JAWA',
        label: 'BPD Jawa Tengah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPKB_IDR: {
        value: 'BPKB',
        label: 'BPD Kalimantan Barat',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPKS_IDR: {
        value: 'BPKS',
        label: 'BPD Kalimantan Selatan',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPKT_IDR: {
        value: 'BPKT',
        label: 'BPD Kalimantan Timur',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPLA_IDR: {
        value: 'BPLA',
        label: 'BPD Lampung',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPRI_IDR: {
        value: 'BPRI',
        label: 'BPD Riau',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPSB_IDR: {
        value: 'BPSB',
        label: 'BPD Sulawesi Selatan dan Barat',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPSU_IDR: {
        value: 'BPSU',
        label: 'BPD Sulawesi Utara',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPSS_IDR: {
        value: 'BPSS',
        label: 'BPD Sumatera Selatan',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BPYO_IDR: {
        value: 'BPYO',
        label: 'BPD Yogyakarta',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    BTNS_IDR: {
        value: 'BTNS',
        label: 'BTN SYARIAH',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    DASY_IDR: {
        value: 'DASY',
        label: 'DANAMON SYARIAH',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    DBAG_IDR: {
        value: 'DBAG',
        label: 'Deutsche Bank AG',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    ICBB_IDR: {
        value: 'ICBB',
        label: 'ICB Bumiputera',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    MAIS_IDR: {
        value: 'MAIS',
        label: 'Maybank Indonesia Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    MASY_IDR: {
        value: 'MASY',
        label: 'Maybank Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    OCNS_IDR: {
        value: 'OCNS',
        label: 'OCBC NISP Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    PESY_IDR: {
        value: 'PESY',
        label: 'Permata Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    QNBK_IDR: {
        value: 'QNBK',
        label: 'QNB Kesawan',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    RABO_IDR: {
        value: 'RABO',
        label: 'Rabobank',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    SISY_IDR: {
        value: 'SISY',
        label: 'Sinarmas Syariah',
        country: countries.id,
        min: 100000,
        max: 25000000,
    },
    ACB_VND: {
        value: 'ACB',
        label: 'Asia Commercial Bank (ACB)',
        country: countries.vn,
    },
    VCB_VND: {
        value: 'VCB',
        label: 'VietcomBank',
        country: countries.vn,
    },
    VietinBank_VND: {
        value: 'VietinBank',
        label: 'Vietnam Bank for Industry and Trade (VietinBank)',
        country: countries.vn,
    },
    TCB_VND: {
        value: 'TCB',
        label: 'Techcombank',
        country: countries.vn,
    },
    BIDV_VND: {
        value: 'BIDV',
        label: 'Bank for Investment & Dof Vietnam (BIDV)',
        country: countries.vn,
    },
    MSB_VND: {
        value: 'MSB',
        label: 'Vietnam Maritime Commercial Joint Stock Bank (MaritimeBank)',
        country: countries.vn,
    },
    VPBank_VND: {
        value: 'VPBank',
        label: 'Vietnam Prosperity Bank (VPBank)',
        country: countries.vn,
    },
    Agribank_VND: {
        value: 'Agribank',
        label: 'Vietnam Bank For Agriculture and Rural Development (Agribank)',
        country: countries.vn,
    },
    Eximbank_VND: {
        value: 'Eximbank',
        label: 'Vietnam Export Import Commercial Joint Stock Bank (Eximbank)',
        country: countries.vn,
    },
    Sacombank_VND: {
        value: 'Sacombank',
        label: 'Saigon Thuong Tin Commercial Joint Stock Bank (Sacombank)',
        country: countries.vn,
    },
    DongABank_VND: {
        value: 'DongABank',
        label: 'DongA Bank',
        country: countries.vn,
    },
    BacABank_VND: {
        value: 'BacABank',
        label: 'North Asia Commercial Joint Stock Bank (NASB)',
        country: countries.vn,
    },
    ANZ_VND: {
        value: 'ANZ',
        label: 'Australia and New Zealand Banking (ANZ Bank)',
        country: countries.vn,
    },
    PNB_VND: {
        value: 'PNB',
        label: 'Southern Commercial Joint Stock Bank (Phuong Nam Bank)',
        country: countries.vn,
    },
    VIB_VND: {
        value: 'VIB',
        label: 'Vietnam International Commercial Joint Stock Bank (VIB)',
        country: countries.vn,
    },
    VietABank_VND: {
        value: 'VietABank',
        label: 'Vietnam Asia Commercial Joint Stock Bank (VietABank)',
        country: countries.vn,
    },
    TPBank_VND: {
        value: 'TPBank',
        label: 'Tien Phong Commercial Joint Stock Bank (TP Bank)',
        country: countries.vn,
    },
    MBBank_VND: {
        value: 'MBBank',
        label: 'MB Bank',
        country: countries.vn,
    },
    Oceanbank_VND: {
        value: 'Oceanbank',
        label: 'OceanBank',
        country: countries.vn,
    },
    PGBank_VND: {
        value: 'PGBank',
        label: 'Petrolimex Group Commercial Joint Stock Bank (PG Bank)',
        country: countries.vn,
    },
    LienVietPostBank_VND: {
        value: 'LienVietPostBank',
        label: 'LienVietPostBank',
        country: countries.vn,
    },
    HSBC_VND: {
        value: 'HSBC',
        label: 'HSBC Bank (Vietnam) Ltd',
        country: countries.vn,
    },
    MHB_VND: {
        value: 'MHB',
        label: 'Mekong Housing Bank (MHB Bank)',
        country: countries.vn,
    },
    SeABank_VND: {
        value: 'SeABank',
        label: 'Southeast Asia Commercial Joint Stock Bank (SeABank)',
        country: countries.vn,
    },
    ABBank_VND: {
        value: 'ABBank',
        label: 'An Binh Commercial Joint Stock Bank (ABBank)',
        country: countries.vn,
    },
    HDBank_VND: {
        value: 'HDBank',
        label: 'HoChiMinh City Development Joint Stock Commercial Bank (HDBank)',
        country: countries.vn,
    },
    GBBank_VND: {
        value: 'GBBank',
        label: 'Global Petro Bank (GBBank)',
        country: countries.vn,
    },
    OCB_VND: {
        value: 'OCB',
        label: 'Orient Commercial Joint Stock Bank (OCB)',
        country: countries.vn,
    },
    SHB_VND: {
        value: 'SHB',
        label: 'Saigon – Hanoi Commercial Joint Stock Bank (SHB)',
        country: countries.vn,
    },
    NamABank_VND: {
        value: 'NamABank',
        label: 'Nam A Commercial Joint Stock Bank',
        country: countries.vn,
    },
    SGB_VND: {
        value: 'SGB',
        label: 'Saigon Bank',
        country: countries.vn,
    },
    SCB_VND: {
        value: 'SCB',
        label: 'Saigon Commercial Bank (SCB)',
        country: countries.vn,
    },
    CB_VND: {
        value: 'CB',
        label: 'Vietnam Construction Joint Stock Commercial Bank (VNCB)',
        country: countries.vn,
    },
    Kienlongbank_VND: {
        value: 'Kienlongbank',
        label: 'Kien Long Commercial Joint Stock Bank (Kienlongbank)',
        country: countries.vn,
    },
    Shinhan_VND: {
        value: 'Shinhan',
        label: 'SHINHAN Bank',
        country: countries.vn,
    },
    BaoVietBank_VND: {
        value: 'BaoVietBank',
        label: 'Baoviet Joint Stock Commercial Bank',
        country: countries.vn,
    },
    Pvcombank_VND: {
        value: 'Pvcombank',
        label: 'Vietnam Public Joint Stock Commercial Bank (Pvcombank)',
        country: countries.vn,
    },
    VRB_VND: {
        value: 'VRB',
        label: 'Vietnam Russia Joint Venture Bank',
        country: countries.vn,
    },
    VietCapitalBank_VND: {
        value: 'VietCapitalBank',
        label: 'Viet Capital Commercial Joint Stock Bank',
        country: countries.vn,
    },
    Standard_Chartered_VND: {
        value: 'Standard_Chartered',
        label: 'Standard Chartered Bank',
        country: countries.vn,
    },
    PUB_MYR: {
        value: 'PUB',
        label: 'PUBLIC BANK BHD',
        country: countries.my,
    },
    MAY_MYR: {
        value: 'MAY',
        label: 'MAYBANK BHD',
        country: countries.my,
    },
    HLB_MYR: {
        value: 'HLB',
        label: 'HONG LEONG BANK BHD',
        country: countries.my,
    },
    CIMB_MYR: {
        value: 'CIMB',
        label: 'CIMB BANK BHD',
        country: countries.my,
    },
    RHB_MYR: {
        value: 'RHB',
        label: 'RHB BANK BHD',
        country: countries.my,
    },
    ALL_MYR: {
        value: 'ALL',
        label: 'ALLIANCE BANK MALAYSIA BHD',
        country: countries.my,
    },
    BCI_IDR: {
        label: 'Bank China trust Indonesia',
        value: 'BCI',
        country: countries.id,
    },
    BII_IDR: {
        label: 'BII MayBank',
        value: 'BII',
        country: countries.id,
    },
    BJABS_IDR: {
        label: 'Bank JABAR Banten SYARIAH',
        value: 'BJABS',
        country: countries.id,
    },
    OVO_IDR: {
        label: 'OVO', value: 'OVO',
        country: countries.id,
    },
    TEST_IDR: {
        label: 'TEST', value: 'TEST',
        country: countries.id,
    },
    ABB_MYR: {
        label: 'AFFIN BANK BHD', value: 'ABB',
        country: countries.my,
    },
    AGROB_MYR: {
        label: 'BANK PERTANIAN MALAYSIA BHD (AGROBANK)',
        value: 'AGROB',
        country: countries.my,
    },
    ALB_MYR: {
        label: 'AL-RAJHI BANK (M) BHD',
        value: 'ALB',
        country: countries.my,
    },
    AMB_MYR: {
        label: 'AMBANK BHD',
        value: 'AMB',
        country: countries.my,
    },
    BIM_MYR: {
        label: 'BANK ISLAM MALAYSIA BHD',
        value: 'BIM',
        country: countries.my,
    },
    BKR_MYR: {
        label: 'BANK KERJASAMA RAKYAT',
        value: 'BKR',
        country: countries.my,
    },
    BMU_MYR: {
        label: 'BANK MUAMALAT',
        value: 'BMU',
        country: countries.my,
    },
    BOA_MYR: {
        label: 'BANK OF AMERICA (M) BERHAD',
        value: 'BOA',
        country: countries.my,
    },
    BOC_MYR: {
        label: 'BANK OF CHINA (MALAYSIA) BERHAD',
        value: 'BOC',
        country: countries.my,
    },
    BPM_MYR: {
        label: 'BNP PARIBAS MALAYSIA BHD',
        value: 'BPM',
        country: countries.my,
    },
    BSN_MYR: {
        label: 'BANK SIMPANAN NASIONAL BHD',
        value: 'BSN',
        country: countries.my,
    },
    CCB_MYR: {
        label: 'CHINA CONSTRUCTION BANK (MALAYSIA) BERHAD',
        value: 'CCB',
        country: countries.my,
    },
    CITI_MYR: {
        label: 'CITIBANK BHD',
        value: 'CITI',
        country: countries.my,
    },
    DEB_MYR: {
        label: 'DEUTSCHE BANK (M) BHD',
        value: 'DEB',
        country: countries.my,
    },
    FCS_MYR: {
        label: 'FINEXUS CARDS SDN BHD',
        value: 'FCS',
        country: countries.my,
    },
    HSBC_MYR: {
        label: 'HSBC BANK MALAYSIA BHD',
        value: 'HSBC',
        country: countries.my,
    },
    ICBC_MYR: {
        label: 'INDUSTRIAL & COMM. BANK OF CHINA (M) BHD',
        value: 'ICBC',
        country: countries.my,
    },
    JPB_MYR: {
        label: 'J.P. MORGAN CHASE BANK BHD',
        value: 'JPB',
        country: countries.my,
    },
    KFH_MYR: {
        label: 'KUWAIT FINANCE HOUSE (M) BHD',
        value: 'KFH',
        country: countries.my,
    },
    MBSB_MYR: {
        label: 'MBSB BANK BERHAD',
        value: 'MBSB',
        country: countries.my,
    },
    MCB_MYR: {
        label: 'MIZUHO CORPORATE BANK (MALAYSIA) BERHAD',
        value: 'MCB',
        country: countries.my,
    },
    MUFG_MYR: {
        label: 'MUFG BANK (MALAYSIA) BERHAD',
        value: 'MUFG',
        country: countries.my,
    },
    OCBC_MYR: {
        label: 'OCBC BANK (M) BHD',
        value: 'OCBC',
        country: countries.my,
    },
    SCB_MYR: {
        label: 'STANDARD CHARTERED BANK BHD',
        value: 'SCB',
        country: countries.my,
    },
    SMB_MYR: {
        label: 'SUMITOMO MITSUI BANK BHD',
        value: 'SMB',
        country: countries.my,
    },
    UOB_MYR: {
        label: 'UNITED OVERSEAS BANK (M) BMD',
        value: 'UOB',
        country: countries.my,
    },
    SPM_PHP: {
        label: 'Smart PayMaya',
        value: 'SPM',
        country: countries.ph,
    },
    ICBCT_THB: {
        label: 'Industrial and Commercial Bank of China',
        value: 'ICBCT',
        country: countries.th,
    },
    TCD_THB: {
        label: 'Thai Credit Retail Bank',
        value: 'TCD',
        country: countries.th,
    },
    TISCO_THB: {
        label: 'Tisco Bank',
        value: 'TISCO',
        country: countries.th,
    },
    Citibank_VND: {
        label: 'CITIBANK N.A.',
        value: 'Citibank',
        country: countries.vn,
    },
});
